// Required external stylesheets and scripts for this component:
// <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/uikit@3.17.11/dist/css/uikit.min.css" />
// <link rel="preconnect" href="https://fonts.googleapis.com">
// <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
// <link href="node_modules/gridstack/dist/gridstack.min.css" rel="stylesheet"/>
// <script src="https://cdn.jsdelivr.net/npm/chart.js@4.4.1/dist/chart.umd.min.js"></script>
// <link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet">
// Please add these to your public/index.html or main HTML file.
import React, { useState, useEffect } from 'react';
import './bottomBar.css';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend as RechartsLegend, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar
} from 'recharts';
import Papa from 'papaparse';
import { summarizeDataByDate, getWeightedAverageGradeByDate } from '../../Utils/summarizeData';

const STOPING_CSV_PATH = process.env.PUBLIC_URL
  ? process.env.PUBLIC_URL + '/files/Stoping_Data_2023_2025.csv'
  : '/files/Stoping_Data_2023_2025.csv';

  // const TRAMMING_CSV_PATH = process.env.PUBLIC_URL
  //   ? process.env.PUBLIC_URL + '/files/Tramming_Data_2023_2025.csv'
  //   : '/files/Tramming_Data_2023_2025.csv';

  const TRAMMING_CSV_PATH = process.env.PUBLIC_URL
  ? process.env.PUBLIC_URL + '/files/Stoping_Data_2023_2025.csv'
  : '/files/Stoping_Data_2023_2025.csv';

const HOISTING_CSV_PATH = process.env.PUBLIC_URL
  ? process.env.PUBLIC_URL + '/files/Hoisting_Data_2023_2025.csv'
  : '/files/Hoisting_Data_2023_2025.csv';

const DEVELOPMENT_CSV_PATH = process.env.PUBLIC_URL
  ? process.env.PUBLIC_URL + '/files/Development_Data_2023_2025.csv'
  : '/files/Development_Data_2023_2025.csv';

const goldMiningData = [
  { name: 'Jan', planned: 1200000, mined: 1150000 },
  { name: 'Feb', planned: 1300000, mined: 1280000 },
  { name: 'Mar', planned: 1350000, mined: 1410000 },
  { name: 'Apr', planned: 1410000, mined: 1390000 },
  { name: 'May', planned: 1380000, mined: 1450000 },
  { name: 'Jun', planned: 1420000, mined: 1510000 },
  { name: 'Jul', planned: 1450000, mined: 1490000 },
];

const goldRecoveryData = [
  { name: 'CIL Process', value: 42, color: '#ffa400' },
  { name: 'Heap Leach', value: 28, color: '#ffce63' },
  { name: 'Gravity Recovery', value: 18, color: '#555555' },
  { name: 'Flotation', value: 12, color: '#333333' },
];

const quarterlyGradeData = [
  {
    name: 'Q1',
    high: 120000,
    medium: 250000,
    low: 180000,
    highTarget: 130000,
    mediumTarget: 260000,
    lowTarget: 190000,
  },
  {
    name: 'Q2',
    high: 150000,
    medium: 230000,
    low: 190000,
    highTarget: 160000,
    mediumTarget: 240000,
    lowTarget: 200000,
  },
  {
    name: 'Q3',
    high: 180000,
    medium: 240000,
    low: 170000,
    highTarget: 190000,
    mediumTarget: 250000,
    lowTarget: 180000,
  },
  {
    name: 'Q4',
    high: 210000,
    medium: 260000,
    low: 200000,
    highTarget: 220000,
    mediumTarget: 270000,
    lowTarget: 210000,
  },
];

const TAB_OPTIONS = [
  { key: 'summary', label: 'Summary' },
  { key: 'stoping', label: 'Stoping' },
  { key: 'tramming', label: 'Tramming' },
  { key: 'hoisting', label: 'Hoisting' },
  { key: 'development', label: 'Development' },
  { key: 'filters', label: 'Filters' },
  { key: 'crusher', label: 'Crusher' },
  { key: 'mill1', label: 'Mill1' },
  { key: 'mill3', label: 'Mill3' },
  { key: 'mill4', label: 'Mill4' },
  { key: 'downtime', label: 'Downtime' },
  { key: 'goldproduced', label: 'Gold Produced' },
];

const BottomBar = ({ expanded: propExpanded, onExpand: propOnExpand, onHide: propOnHide }) => {
  const [expanded, setExpanded] = useState(propExpanded || false);
  
  // Update internal state when prop changes
  React.useEffect(() => {
    //console.log('BottomBar: propExpanded changed to:', propExpanded);
    setExpanded(propExpanded);
  }, [propExpanded]);
  const [selectedTab, setSelectedTab] = useState('summary');
  const [AllStopingData, setAllStopingData] = useState(null);
  const [stopingLoading, setStopingLoading] = useState(false);
  const [stopingError, setStopingError] = useState(null);
  const [dateRange, setDateRange] = useState({ min: 0, max: 100 });
  const [filteredStopingData, setFilteredStopingData] = useState(null);
  const [dateBounds, setDateBounds] = useState({ min: null, max: null });
  const [xAxisOption, setXAxisOption] = useState('date'); // 'date', 'month', 'year', 'stope'
  const [summarizedChartData, setSummarizedChartData] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedStopeIds, setSelectedStopeIds] = useState([]);
  const [showStopeFilter, setShowStopeFilter] = useState(false);
  const [allStopeIds, setAllStopeIds] = useState([]);
  const [tempSelectedStopes, setTempSelectedStopes] = useState([]);
  const [selectedLevels, setSelectedLevels] = useState([]);
  const [showLevelFilter, setShowLevelFilter] = useState(false);
  const [allLevels, setAllLevels] = useState([]);
  const [tempSelectedLevels, setTempSelectedLevels] = useState([]);
  const [AllTrammingData, setAllTrammingData] = useState(null);
  const [trammingLoading, setTrammingLoading] = useState(false);
  const [trammingError, setTrammingError] = useState(null);
  const [filteredTrammingData, setFilteredTrammingData] = useState(null);
  const [trammingDateBounds, setTrammingDateBounds] = useState({ min: null, max: null });
  const [trammingXAxisOption, setTrammingXAxisOption] = useState('date');
  const [trammingSummarizedChartData, setTrammingSummarizedChartData] = useState(null);
  const [trammingStartDate, setTrammingStartDate] = useState('');
  const [trammingEndDate, setTrammingEndDate] = useState('');
  const [trammingSelectedStopeIds, setTrammingSelectedStopeIds] = useState([]);
  const [trammingShowStopeFilter, setTrammingShowStopeFilter] = useState(false);
  const [trammingAllStopeIds, setTrammingAllStopeIds] = useState([]);
  const [trammingTempSelectedStopes, setTrammingTempSelectedStopes] = useState([]);
  const [trammingSelectedLevels, setTrammingSelectedLevels] = useState([]);
  const [trammingShowLevelFilter, setTrammingShowLevelFilter] = useState(false);
  const [trammingAllLevels, setTrammingAllLevels] = useState([]);
  const [trammingTempSelectedLevels, setTrammingTempSelectedLevels] = useState([]);
  const [AllHoistingData, setAllHoistingData] = useState(null);
  const [hoistingLoading, setHoistingLoading] = useState(false);
  const [hoistingError, setHoistingError] = useState(null);
  const [filteredHoistingData, setFilteredHoistingData] = useState(null);
  const [hoistingDateBounds, setHoistingDateBounds] = useState({ min: null, max: null });
  const [hoistingXAxisOption, setHoistingXAxisOption] = useState('date');
  const [hoistingSummarizedChartData, setHoistingSummarizedChartData] = useState(null);
  const [hoistingStartDate, setHoistingStartDate] = useState('');
  const [hoistingEndDate, setHoistingEndDate] = useState('');
  const [AllDevelopmentData, setAllDevelopmentData] = useState(null);
  const [developmentLoading, setDevelopmentLoading] = useState(false);
  const [developmentError, setDevelopmentError] = useState(null);
  const [filteredDevelopmentData, setFilteredDevelopmentData] = useState(null);
  const [developmentDateBounds, setDevelopmentDateBounds] = useState({ min: null, max: null });
  const [developmentXAxisOption, setDevelopmentXAxisOption] = useState('date');
  const [developmentSummarizedChartData, setDevelopmentSummarizedChartData] = useState(null);
  const [developmentStartDate, setDevelopmentStartDate] = useState('');
  const [developmentEndDate, setDevelopmentEndDate] = useState('');
  // Add Development EndID filter state
  const [selectedEndIDs, setSelectedEndIDs] = useState([]);
  const [showEndIDFilter, setShowEndIDFilter] = useState(false);
  const [allEndIDs, setAllEndIDs] = useState([]);
  const [tempSelectedEndIDs, setTempSelectedEndIDs] = useState([]);

  // Summary tab state variables
  const [summaryDateBounds, setSummaryDateBounds] = useState({ min: null, max: null });
  const [summaryXAxisOption, setSummaryXAxisOption] = useState('date');
  const [summaryStartDate, setSummaryStartDate] = useState('');
  const [summaryEndDate, setSummaryEndDate] = useState('');
  const [summarySummarizedChartData, setSummarySummarizedChartData] = useState(null);

  // Shared date range state for all tabs
  const [sharedStartDate, setSharedStartDate] = useState('');
  const [sharedEndDate, setSharedEndDate] = useState('');
  const [sharedDateBounds, setSharedDateBounds] = useState({ min: null, max: null });

  // Processing data state variables
  const [crushingData, setCrushingData] = useState([]);
  const [mill1Data, setMill1Data] = useState([]);
  const [mill3Data, setMill3Data] = useState([]);
  const [mill4Data, setMill4Data] = useState([]);
  const [goldProducedData, setGoldProducedData] = useState([]);
  const [downtimeData, setDowntimeData] = useState([]);
  const [commentsData, setCommentsData] = useState([]);
  const [millingPlanData, setMillingPlanData] = useState([]);
  const [loading, setLoading] = useState({
    crushing: false,
    mill1: false,
    mill3: false,
    mill4: false,
    goldProduced: false,
    downtime: false,
    comments: false,
    millingPlan: false
  });

  // Processing filter state
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [activeDateRange, setActiveDateRange] = useState('thisMonth');
  const [filteredData, setFilteredData] = useState({
    crushing: [],
    mill1: [],
    mill3: [],
    mill4: [],
    goldProduced: [],
    downtime: [],
    comments: [],
    millingPlan: []
  });

  // Collapsible sections state for downtime tab
  const [collapsedSections, setCollapsedSections] = useState({
    effectiveRunningTime: true,
    availability: true,
    utilization: true
  });

  // API Base URL
  const API_BASE_URL = 'https://pickstonepresentation.dumisaminerals.com/server/api';

  // Function to summarize data based on X-axis selection
  const summarizeDataForCharts = (data, xAxisType) => {
    if (!data || data.length === 0) return [];

    switch (xAxisType) {
      case 'date':
        // Group by individual dates
        const dateGroups = {};
        data.forEach(row => {
          if (!row.Date) return;
          const dateKey = row.Date;
          if (!dateGroups[dateKey]) {
            dateGroups[dateKey] = {
              date: dateKey,
              totalActualTonnage: 0,
              totalBudgetTonnage: 0,
              totalActualGradeTonnage: 0,
              totalBudgetGradeTonnage: 0,
              totalActualKgs: 0,
              totalBudgetKgs: 0,
              count: 0
            };
          }
          
          const actualTonnage = parseFloat(row.Stoping_Actual_t) || 0;
          const budgetTonnage = parseFloat(row.Stoping_Budget_t) || 0;
          const breakingPlanTonnage = parseFloat(row.FY2025_Breaking_Plan_t) || 0;
          const actualGrade = parseFloat(row.Stoping_Actual_gpt) || 0;
          const budgetGrade = parseFloat(row.Stoping_Budget_gpt) || 0;
          const breakingPlanGrade = parseFloat(row.FY2025_Breaking_Plan_gpt) || 0;
          const actualKgs = parseFloat(row.Stoping_Actual_kgs) || 0;
          const budgetKgs = parseFloat(row.Stoping_Budget_kgs) || 0;
          const breakingPlanKgs = parseFloat(row.FY2025_Breaking_Plan_kgs) || 0;

          dateGroups[dateKey].totalActualTonnage += actualTonnage;
          dateGroups[dateKey].totalBudgetTonnage += budgetTonnage;
          dateGroups[dateKey].totalBreakingPlanTonnage += breakingPlanTonnage;
          dateGroups[dateKey].totalActualGradeTonnage += (actualTonnage * actualGrade);
          dateGroups[dateKey].totalBudgetGradeTonnage += (budgetTonnage * budgetGrade);
          dateGroups[dateKey].totalBreakingPlanGradeTonnage += (breakingPlanTonnage * breakingPlanGrade);
          dateGroups[dateKey].totalActualKgs += actualKgs;
          dateGroups[dateKey].totalBudgetKgs += budgetKgs;
          dateGroups[dateKey].totalBreakingPlanKgs += breakingPlanKgs;
          dateGroups[dateKey].count++;
        });

        return Object.values(dateGroups).map(group => ({
          ...group,
          Stoping_Actual_t: group.totalActualTonnage,
          Stoping_Budget_t: group.totalBudgetTonnage,
          FY2025_Breaking_Plan_t: group.totalBreakingPlanTonnage,
          Stoping_Actual_gpt: group.totalActualTonnage > 0 ? group.totalActualGradeTonnage / group.totalActualTonnage : 0,
          Stoping_Budget_gpt: group.totalBudgetTonnage > 0 ? group.totalBudgetGradeTonnage / group.totalBudgetTonnage : 0,
          FY2025_Breaking_Plan_gpt: group.totalBreakingPlanTonnage > 0 ? group.totalBreakingPlanGradeTonnage / group.totalBreakingPlanTonnage : 0,
          Stoping_Actual_kgs: group.totalActualKgs,
          Stoping_Budget_kgs: group.totalBudgetKgs,
          FY2025_Breaking_Plan_kgs: group.totalBreakingPlanKgs,
          Date: group.date
        })).sort((a, b) => {
          // Sort by date (DD/MM/YYYY format)
          const aParts = a.Date.split('/');
          const bParts = b.Date.split('/');
          const aDate = new Date(parseInt(aParts[2]), parseInt(aParts[1]) - 1, parseInt(aParts[0]));
          const bDate = new Date(parseInt(bParts[2]), parseInt(bParts[1]) - 1, parseInt(bParts[0]));
          return aDate - bDate;
        });

      case 'month':
        const actualMonthData = getWeightedAverageGradeByDate(data, 'Date', 'Stoping_Actual_t', 'Stoping_Actual_gpt', 'month');
        const budgetMonthData = getWeightedAverageGradeByDate(data, 'Date', 'Stoping_Budget_t', 'Stoping_Budget_gpt', 'month');
        const breakingPlanMonthData = getWeightedAverageGradeByDate(data, 'Date', 'FY2025_Breaking_Plan_t', 'FY2025_Breaking_Plan_gpt', 'month');
        
        return actualMonthData.map(month => {
          const budgetMonth = budgetMonthData.find(b => b.period === month.period);
          const breakingPlanMonth = breakingPlanMonthData.find(b => b.period === month.period);
          return {
            Date: month.period,
            Stoping_Actual_t: month.totalTonnage,
            Stoping_Budget_t: budgetMonth ? budgetMonth.totalTonnage : 0,
            FY2025_Breaking_Plan_t: breakingPlanMonth ? breakingPlanMonth.totalTonnage : 0,
            Stoping_Actual_gpt: month.weightedAverage,
            Stoping_Budget_gpt: budgetMonth ? budgetMonth.weightedAverage : 0,
            FY2025_Breaking_Plan_gpt: breakingPlanMonth ? breakingPlanMonth.weightedAverage : 0,
            Stoping_Actual_kgs: month.totalTonnage * month.weightedAverage / 31.1035, // Convert to kgs
            Stoping_Budget_kgs: budgetMonth ? budgetMonth.totalTonnage * budgetMonth.weightedAverage / 31.1035 : 0,
            FY2025_Breaking_Plan_kgs: breakingPlanMonth ? breakingPlanMonth.totalTonnage * breakingPlanMonth.weightedAverage / 31.1035 : 0
          };
        });

      case 'year':
        const actualYearData = getWeightedAverageGradeByDate(data, 'Date', 'Stoping_Actual_t', 'Stoping_Actual_gpt', 'year');
        const budgetYearData = getWeightedAverageGradeByDate(data, 'Date', 'Stoping_Budget_t', 'Stoping_Budget_gpt', 'year');
        const breakingPlanYearData = getWeightedAverageGradeByDate(data, 'Date', 'FY2025_Breaking_Plan_t', 'FY2025_Breaking_Plan_gpt', 'year');
        
        return actualYearData.map(year => {
          const budgetYear = budgetYearData.find(b => b.period === year.period);
          const breakingPlanYear = breakingPlanYearData.find(b => b.period === year.period);
          return {
            Date: year.period,
            Stoping_Actual_t: year.totalTonnage,
            Stoping_Budget_t: budgetYear ? budgetYear.totalTonnage : 0,
            FY2025_Breaking_Plan_t: breakingPlanYear ? breakingPlanYear.totalTonnage : 0,
            Stoping_Actual_gpt: year.weightedAverage,
            Stoping_Budget_gpt: budgetYear ? budgetYear.weightedAverage : 0,
            FY2025_Breaking_Plan_gpt: breakingPlanYear ? breakingPlanYear.weightedAverage : 0,
            Stoping_Actual_kgs: year.totalTonnage * year.weightedAverage / 31.1035,
            Stoping_Budget_kgs: budgetYear ? budgetYear.totalTonnage * budgetYear.weightedAverage / 31.1035 : 0,
            FY2025_Breaking_Plan_kgs: breakingPlanYear ? breakingPlanYear.totalTonnage * breakingPlanYear.weightedAverage / 31.1035 : 0
          };
        });

      case 'stope':
        // Group by Stope ID
        const stopeGroups = {};
        data.forEach(row => {
          if (!row.ID) return;
          const stopeKey = row.ID;
          if (!stopeGroups[stopeKey]) {
            stopeGroups[stopeKey] = {
              ID: stopeKey,
              totalActualTonnage: 0,
              totalBudgetTonnage: 0,
              totalBreakingPlanTonnage: 0,
              totalActualGradeTonnage: 0,
              totalBudgetGradeTonnage: 0,
              totalBreakingPlanGradeTonnage: 0,
              totalActualKgs: 0,
              
              totalBudgetKgs: 0,
              totalBreakingPlanKgs: 0,
              count: 0
            };
          }
          
          const actualTonnage = parseFloat(row.Stoping_Actual_t) || 0;
          const budgetTonnage = parseFloat(row.Stoping_Budget_t) || 0;
          const breakingPlanTonnage = parseFloat(row.FY2025_Breaking_Plan_t) || 0;
          const actualGrade = parseFloat(row.Stoping_Actual_gpt) || 0;
          const budgetGrade = parseFloat(row.Stoping_Budget_gpt) || 0;
          const breakingPlanGrade = parseFloat(row.FY2025_Breaking_Plan_gpt) || 0;
          const actualKgs = parseFloat(row.Stoping_Actual_kgs) || 0;
          const budgetKgs = parseFloat(row.Stoping_Budget_kgs) || 0;
          const breakingPlanKgs = parseFloat(row.FY2025_Breaking_Plan_kgs) || 0;

          stopeGroups[stopeKey].totalActualTonnage += actualTonnage;
          stopeGroups[stopeKey].totalBudgetTonnage += budgetTonnage;
          stopeGroups[stopeKey].totalBreakingPlanTonnage += breakingPlanTonnage;
          stopeGroups[stopeKey].totalActualGradeTonnage += (actualTonnage * actualGrade);
          stopeGroups[stopeKey].totalBudgetGradeTonnage += (budgetTonnage * budgetGrade);
          stopeGroups[stopeKey].totalBreakingPlanGradeTonnage += (breakingPlanTonnage * breakingPlanGrade);
          stopeGroups[stopeKey].totalActualKgs += actualKgs;
          stopeGroups[stopeKey].totalBudgetKgs += budgetKgs;
          stopeGroups[stopeKey].totalBreakingPlanKgs += breakingPlanKgs;
          stopeGroups[stopeKey].count++;
        });

        return Object.values(stopeGroups).map(group => ({
          ...group,
          Stoping_Actual_t: group.totalActualTonnage,
          Stoping_Budget_t: group.totalBudgetTonnage,
          FY2025_Breaking_Plan_t: group.totalBreakingPlanTonnage,
          Stoping_Actual_gpt: group.totalActualTonnage > 0 ? group.totalActualGradeTonnage / group.totalActualTonnage : 0,
          Stoping_Budget_gpt: group.totalBudgetTonnage > 0 ? group.totalBudgetGradeTonnage / group.totalBudgetTonnage : 0,
          FY2025_Breaking_Plan_gpt: group.totalBreakingPlanTonnage > 0 ? group.totalBreakingPlanGradeTonnage / group.totalBreakingPlanTonnage : 0,
          Stoping_Actual_kgs: group.totalActualKgs,
          Stoping_Budget_kgs: group.totalBudgetKgs,
          FY2025_Breaking_Plan_kgs: group.totalBreakingPlanKgs,
          Date: group.ID // Use ID as the Date field for charts
        })).sort((a, b) => a.ID.localeCompare(b.ID));

      default:
        return data;
    }
  };

  // Update summarized data when filtered data or x-axis option changes
  useEffect(() => {
    if (filteredStopingData) {
      const summarized = summarizeDataForCharts(filteredStopingData, xAxisOption);
      setSummarizedChartData(summarized);
    }
  }, [filteredStopingData, xAxisOption]);

  useEffect(() => {
    if (selectedTab === 'stoping' && !AllStopingData && !stopingLoading) {
      setStopingLoading(true);
      fetch(STOPING_CSV_PATH)
        .then((response) => {
          if (!response.ok) throw new Error('Failed to fetch Stoping data');
          return response.text();
        })
        .then((csvText) => {
          const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });
          setAllStopingData(parsed.data);
          setStopingLoading(false);
        })
        .catch((err) => {
          setStopingError(err.message);
          setStopingLoading(false);
        });
    }
  }, [selectedTab, AllStopingData, stopingLoading]);

  // useEffect(() => {
  //   console.log(AllStopingData);
  // }, [AllStopingData]);

  // Calculate date bounds and filter data when AllStopingData changes
  useEffect(() => {
    if (AllStopingData && AllStopingData.length > 0) {
      // Use shared date bounds instead of calculating separate ones
      setDateBounds(sharedDateBounds);
      
      // Set initial date range to full range
      setDateRange({ min: 0, max: 100 });
      
      // Shared dates are handled by the shared state, no need to set individual dates

      // Extract all unique stope IDs
      const stopeIds = [...new Set(AllStopingData.map(row => row.ID).filter(id => id))].sort();
      setAllStopeIds(stopeIds);
      setSelectedStopeIds(stopeIds); // Initially select all stope IDs
      setTempSelectedStopes(stopeIds);

      // Extract all unique levels from stope IDs (e.g., "6L_W14_STOPE" -> "6L")
      const levels = [...new Set(stopeIds.map(stopeId => {
        const match = stopeId.match(/^(\d+L)/);
        return match ? match[1] : null;
      }).filter(level => level))].sort();
      setAllLevels(levels);
      setSelectedLevels(levels); // Initially select all levels
      setTempSelectedLevels(levels);
    }
  }, [AllStopingData, sharedDateBounds, sharedStartDate, sharedEndDate]);

  // Filter data based on shared date range and stope IDs
  useEffect(() => {
    if (AllStopingData && sharedStartDate && sharedEndDate && selectedStopeIds.length > 0 && selectedLevels.length > 0) {
      const start = parseInputDate(sharedStartDate);
      const end = parseInputDate(sharedEndDate);
      
      if (start && end) {
        const filtered = AllStopingData.filter(row => {
          // Check date filter (inclusive of start and end)
          if (!row.Date) return false;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            // DD/MM/YYYY format
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            // Inclusive filter
            const dateInRange = rowDate >= start && rowDate <= end;
            
            // Check stope ID filter
            const stopeInRange = selectedStopeIds.includes(row.ID);
            
            // Check level filter
            const levelMatch = row.ID ? row.ID.match(/^(\d+L)/) : null;
            const rowLevel = levelMatch ? levelMatch[1] : null;
            const levelInRange = rowLevel && selectedLevels.includes(rowLevel);
            
            return dateInRange && stopeInRange && levelInRange;
          }
          return false;
        });
        
        setFilteredStopingData(filtered);
      }
    }
  }, [AllStopingData, sharedStartDate, sharedEndDate, selectedStopeIds, selectedLevels]);

  // Update selected stopes when levels change
  useEffect(() => {
    if (selectedLevels.length > 0) {
      const availableStopes = allStopeIds.filter(stopeId => {
        const levelMatch = stopeId.match(/^(\d+L)/);
        const stopeLevel = levelMatch ? levelMatch[1] : null;
        return stopeLevel && selectedLevels.includes(stopeLevel);
      });
      
      // Keep only stopes that are still available after level filtering
      const updatedSelectedStopes = selectedStopeIds.filter(stopeId => 
        availableStopes.includes(stopeId)
      );
      
      if (updatedSelectedStopes.length !== selectedStopeIds.length) {
        setSelectedStopeIds(updatedSelectedStopes);
        setTempSelectedStopes(updatedSelectedStopes);
      }
    }
  }, [selectedLevels, allStopeIds]);

  const handleDateRangeChange = (event, newValue) => {
    setDateRange({ min: newValue[0], max: newValue[1] });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };


  // Helper function to format date for input field (YYYY-MM-DD)
  const formatDateForInput = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Helper function to parse input date (YYYY-MM-DD) to Date object
  const parseInputDate = (dateString) => {
    if (!dateString) return null;
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day, 0, 0, 0, 0);
    return isNaN(date.getTime()) ? null : date;
  };

  // Stope filter functions
  const handleSelectAllStopes = () => {
    setTempSelectedStopes([...allStopeIds]);
  };

  const handleUnselectAllStopes = () => {
    setTempSelectedStopes([]);
  };

  const handleStopeToggle = (stopeId) => {
    setTempSelectedStopes(prev => 
      prev.includes(stopeId) 
        ? prev.filter(id => id !== stopeId)
        : [...prev, stopeId]
    );
  };

  const handleApplyStopeFilter = () => {
    setSelectedStopeIds([...tempSelectedStopes]);
    setShowStopeFilter(false);
  };

  const handleCancelStopeFilter = () => {
    setTempSelectedStopes([...selectedStopeIds]);
    setShowStopeFilter(false);
  };

  const openStopeFilter = () => {
    setTempSelectedStopes([...selectedStopeIds]);
    setShowStopeFilter(true);
  };

  // Level filter functions
  const handleSelectAllLevels = () => {
    setTempSelectedLevels([...allLevels]);
  };

  const handleUnselectAllLevels = () => {
    setTempSelectedLevels([]);
  };

  const handleLevelToggle = (level) => {
    setTempSelectedLevels(prev => 
      prev.includes(level) 
        ? prev.filter(l => l !== level)
        : [...prev, level]
    );
  };

  const handleApplyLevelFilter = () => {
    setSelectedLevels([...tempSelectedLevels]);
    setShowLevelFilter(false);
  };

  const handleCancelLevelFilter = () => {
    setTempSelectedLevels([...selectedLevels]);
    setShowLevelFilter(false);
  };

  const openLevelFilter = () => {
    setTempSelectedLevels([...selectedLevels]);
    setShowLevelFilter(true);
  };

  // Tramming summarization function
  const summarizeTrammingDataForCharts = (data, xAxisType) => {
    if (!data || data.length === 0) return [];
    switch (xAxisType) {
      case 'date': {
        const dateGroups = {};
        data.forEach(row => {
          if (!row.Date) return;
          const dateKey = row.Date;
          if (!dateGroups[dateKey]) {
            dateGroups[dateKey] = {
              date: dateKey,
              totalActualTonnage: 0,
              totalBudgetTonnage: 0,
              totalActualGradeTonnage: 0,
              totalBudgetGradeTonnage: 0,
              totalActualKgs: 0,
              totalBudgetKgs: 0,
              count: 0
            };
          }
          const actualTonnage = parseFloat(row.Tramming_Actual_t) || 0;
          const budgetTonnage = parseFloat(row.Tramming_Budget_t) || 0;
          const actualGrade = parseFloat(row.Tramming_Actual_gpt) || 0;
          const budgetGrade = parseFloat(row.Tramming_Budget_gpt) || 0;
          const actualKgs = parseFloat(row.Tramming_Actual_kgs) || 0;
          const budgetKgs = parseFloat(row.Tramming_Budget_kgs) || 0;
          dateGroups[dateKey].totalActualTonnage += actualTonnage;
          dateGroups[dateKey].totalBudgetTonnage += budgetTonnage;
          dateGroups[dateKey].totalActualGradeTonnage += (actualTonnage * actualGrade);
          dateGroups[dateKey].totalBudgetGradeTonnage += (budgetTonnage * budgetGrade);
          dateGroups[dateKey].totalActualKgs += actualKgs;
          dateGroups[dateKey].totalBudgetKgs += budgetKgs;
          dateGroups[dateKey].count++;
        });
        return Object.values(dateGroups).map(group => ({
          ...group,
          Tramming_Actual_t: group.totalActualTonnage,
          Tramming_Budget_t: group.totalBudgetTonnage,
          Tramming_Actual_gpt: group.totalActualTonnage > 0 ? group.totalActualGradeTonnage / group.totalActualTonnage : 0,
          Tramming_Budget_gpt: group.totalBudgetTonnage > 0 ? group.totalBudgetGradeTonnage / group.totalBudgetTonnage : 0,
          Tramming_Actual_kgs: group.totalActualKgs,
          Tramming_Budget_kgs: group.totalBudgetKgs,
          Date: group.date
        })).sort((a, b) => {
          const aParts = a.Date.split('/');
          const bParts = b.Date.split('/');
          const aDate = new Date(parseInt(aParts[2]), parseInt(aParts[1]) - 1, parseInt(aParts[0]));
          const bDate = new Date(parseInt(bParts[2]), parseInt(bParts[1]) - 1, parseInt(bParts[0]));
          return aDate - bDate;
        });
      }
      case 'month':
        return getWeightedAverageGradeByDate(data, 'Date', 'Tramming_Actual_t', 'Tramming_Actual_gpt', 'month').map(month => ({
          Date: month.period,
          Tramming_Actual_t: month.totalTonnage,
          Tramming_Budget_t: month.totalTonnage,
          Tramming_Actual_gpt: month.weightedAverage,
          Tramming_Budget_gpt: month.weightedAverage,
          Tramming_Actual_kgs: month.totalTonnage * month.weightedAverage / 31.1035,
          Tramming_Budget_kgs: month.totalTonnage * month.weightedAverage / 31.1035
        }));
      case 'year':
        return getWeightedAverageGradeByDate(data, 'Date', 'Tramming_Actual_t', 'Tramming_Actual_gpt', 'year').map(year => ({
          Date: year.period,
          Tramming_Actual_t: year.totalTonnage,
          Tramming_Budget_t: year.totalTonnage,
          Tramming_Actual_gpt: year.weightedAverage,
          Tramming_Budget_gpt: year.weightedAverage,
          Tramming_Actual_kgs: year.totalTonnage * year.weightedAverage / 31.1035,
          Tramming_Budget_kgs: year.totalTonnage * year.weightedAverage / 31.1035
        }));
      case 'stope': {
        const stopeGroups = {};
        data.forEach(row => {
          if (!row.ID) return;
          const stopeKey = row.ID;
          if (!stopeGroups[stopeKey]) {
            stopeGroups[stopeKey] = {
              ID: stopeKey,
              totalActualTonnage: 0,
              totalBudgetTonnage: 0,
              totalActualGradeTonnage: 0,
              totalBudgetGradeTonnage: 0,
              totalActualKgs: 0,
              totalBudgetKgs: 0,
              count: 0
            };
          }
          const actualTonnage = parseFloat(row.Tramming_Actual_t) || 0;
          const budgetTonnage = parseFloat(row.Tramming_Budget_t) || 0;
          const actualGrade = parseFloat(row.Tramming_Actual_gpt) || 0;
          const budgetGrade = parseFloat(row.Tramming_Budget_gpt) || 0;
          const actualKgs = parseFloat(row.Tramming_Actual_kgs) || 0;
          const budgetKgs = parseFloat(row.Tramming_Budget_kgs) || 0;
          stopeGroups[stopeKey].totalActualTonnage += actualTonnage;
          stopeGroups[stopeKey].totalBudgetTonnage += budgetTonnage;
          stopeGroups[stopeKey].totalActualGradeTonnage += (actualTonnage * actualGrade);
          stopeGroups[stopeKey].totalBudgetGradeTonnage += (budgetTonnage * budgetGrade);
          stopeGroups[stopeKey].totalActualKgs += actualKgs;
          stopeGroups[stopeKey].totalBudgetKgs += budgetKgs;
          stopeGroups[stopeKey].count++;
        });
        return Object.values(stopeGroups).map(group => ({
          ...group,
          Tramming_Actual_t: group.totalActualTonnage,
          Tramming_Budget_t: group.totalBudgetTonnage,
          Tramming_Actual_gpt: group.totalActualTonnage > 0 ? group.totalActualGradeTonnage / group.totalActualTonnage : 0,
          Tramming_Budget_gpt: group.totalBudgetTonnage > 0 ? group.totalBudgetGradeTonnage / group.totalBudgetTonnage : 0,
          Tramming_Actual_kgs: group.totalActualKgs,
          Tramming_Budget_kgs: group.totalBudgetKgs,
          Date: group.ID
        })).sort((a, b) => a.ID.localeCompare(b.ID));
      }
      default:
        return data;
    }
  };

  // Tramming data loading effect
  useEffect(() => {
    if (selectedTab === 'tramming' && !AllTrammingData && !trammingLoading) {
      setTrammingLoading(true);
      fetch(TRAMMING_CSV_PATH)
        .then((response) => {
          if (!response.ok) throw new Error('Failed to fetch Tramming data');
          return response.text();
        })
        .then((csvText) => {
          const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });
          setAllTrammingData(parsed.data);
          setTrammingLoading(false);
        })
        .catch((err) => {
          setTrammingError(err.message);
          setTrammingLoading(false);
        });
    }
  }, [selectedTab, AllTrammingData, trammingLoading]);

  // Tramming bounds and filter effect
  useEffect(() => {
    if (AllTrammingData && AllTrammingData.length > 0) {
      // Use shared date bounds instead of calculating separate ones
      setTrammingDateBounds(sharedDateBounds);
      
      // Shared dates are handled by the shared state, no need to set individual dates
      
      const stopeIds = [...new Set(AllTrammingData.map(row => row.ID).filter(id => id))].sort();
      setTrammingAllStopeIds(stopeIds);
      setTrammingSelectedStopeIds(stopeIds);
      setTrammingTempSelectedStopes(stopeIds);
      const levels = [...new Set(stopeIds.map(stopeId => {
        const match = stopeId.match(/^([0-9]+L)/);
        return match ? match[1] : null;
      }).filter(level => level))].sort();
      setTrammingAllLevels(levels);
      setTrammingSelectedLevels(levels);
      setTrammingTempSelectedLevels(levels);
    }
  }, [AllTrammingData, sharedDateBounds, sharedStartDate, sharedEndDate]);

  // Tramming filter effect
  useEffect(() => {
    if (AllTrammingData && sharedStartDate && sharedEndDate && trammingSelectedStopeIds.length > 0 && trammingSelectedLevels.length > 0) {
      const start = parseInputDate(sharedStartDate);
      const end = parseInputDate(sharedEndDate);
      if (start && end) {
        const filtered = AllTrammingData.filter(row => {
          // Check date filter (inclusive of start and end)
          if (!row.Date) return false;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            // Inclusive filter
            const dateInRange = rowDate >= start && rowDate <= end;
            const stopeInRange = trammingSelectedStopeIds.includes(row.ID);
            const levelMatch = row.ID ? row.ID.match(/^([0-9]+L)/) : null;
            const rowLevel = levelMatch ? levelMatch[1] : null;
            const levelInRange = rowLevel && trammingSelectedLevels.includes(rowLevel);
            return dateInRange && stopeInRange && levelInRange;
          }
          return false;
        });
        setFilteredTrammingData(filtered);
      }
    }
  }, [AllTrammingData, sharedStartDate, sharedEndDate, trammingSelectedStopeIds, trammingSelectedLevels]);

  // Tramming update summarized data effect
  useEffect(() => {
    if (filteredTrammingData) {
      const summarized = summarizeTrammingDataForCharts(filteredTrammingData, trammingXAxisOption);
      setTrammingSummarizedChartData(summarized);
    }
  }, [filteredTrammingData, trammingXAxisOption]);

  // Add Tramming filter handler functions after the Stoping ones
  const handleTrammingSelectAllStopes = () => setTrammingTempSelectedStopes([...trammingAllStopeIds]);
  const handleTrammingUnselectAllStopes = () => setTrammingTempSelectedStopes([]);
  const handleTrammingStopeToggle = (stopeId) => setTrammingTempSelectedStopes(prev => prev.includes(stopeId) ? prev.filter(id => id !== stopeId) : [...prev, stopeId]);
  const handleTrammingApplyStopeFilter = () => { setTrammingSelectedStopeIds([...trammingTempSelectedStopes]); setTrammingShowStopeFilter(false); };
  const handleTrammingCancelStopeFilter = () => { setTrammingTempSelectedStopes([...trammingSelectedStopeIds]); setTrammingShowStopeFilter(false); };
  const openTrammingStopeFilter = () => { setTrammingTempSelectedStopes([...trammingSelectedStopeIds]); setTrammingShowStopeFilter(true); };
  const handleTrammingSelectAllLevels = () => setTrammingTempSelectedLevels([...trammingAllLevels]);
  const handleTrammingUnselectAllLevels = () => setTrammingTempSelectedLevels([]);
  const handleTrammingLevelToggle = (level) => setTrammingTempSelectedLevels(prev => prev.includes(level) ? prev.filter(l => l !== level) : [...prev, level]);
  const handleTrammingApplyLevelFilter = () => { setTrammingSelectedLevels([...trammingTempSelectedLevels]); setTrammingShowLevelFilter(false); };
  const handleTrammingCancelLevelFilter = () => { setTrammingTempSelectedLevels([...trammingSelectedLevels]); setTrammingShowLevelFilter(false); };
  const openTrammingLevelFilter = () => { setTrammingTempSelectedLevels([...trammingSelectedLevels]); setTrammingShowLevelFilter(true); };

  // Hoisting summarization function
  const summarizeHoistingDataForCharts = (data, xAxisType) => {
    if (!data || data.length === 0) return [];
    switch (xAxisType) {
      case 'date': {
        const dateGroups = {};
        data.forEach(row => {
          if (!row.DATE) return;
          const dateKey = row.DATE;
          if (!dateGroups[dateKey]) {
            dateGroups[dateKey] = {
              date: dateKey,
              totalPlannedTonnes: 0,
              totalActualTonnes: 0,
              totalPlannedGradeTonnes: 0,
              totalActualGradeTonnes: 0,
              totalPlannedContent: 0,
              totalActualContent: 0,
              count: 0
            };
          }
          const plannedTonnes = parseFloat(row.Planned_Tonnes) || 0;
          const actualTonnes = parseFloat(row.Actual_Tonnes) || 0;
          const plannedGrade = parseFloat(row.Planned_Grade) || 0;
          const actualGrade = parseFloat(row.Actual_Grades) || 0;
          const plannedContent = parseFloat(row.Planned_Content) || 0;
          const actualContent = parseFloat(row.Actual_Content) || 0;
          dateGroups[dateKey].totalPlannedTonnes += plannedTonnes;
          dateGroups[dateKey].totalActualTonnes += actualTonnes;
          dateGroups[dateKey].totalPlannedGradeTonnes += (plannedTonnes * plannedGrade);
          dateGroups[dateKey].totalActualGradeTonnes += (actualTonnes * actualGrade);
          dateGroups[dateKey].totalPlannedContent += plannedContent;
          dateGroups[dateKey].totalActualContent += actualContent;
          dateGroups[dateKey].count++;
        });
        return Object.values(dateGroups).map(group => ({
          ...group,
          Planned_Tonnes: group.totalPlannedTonnes,
          Actual_Tonnes: group.totalActualTonnes,
          Planned_Grade: group.totalPlannedTonnes > 0 ? group.totalPlannedGradeTonnes / group.totalPlannedTonnes : 0,
          Actual_Grades: group.totalActualTonnes > 0 ? group.totalActualGradeTonnes / group.totalActualTonnes : 0,
          Planned_Content: group.totalPlannedContent,
          Actual_Content: group.totalActualContent,
          DATE: group.date
        })).sort((a, b) => {
          // Sort by date (DD/MM/YYYY format)
          const aParts = a.DATE.split('/');
          const bParts = b.DATE.split('/');
          const aDate = new Date(parseInt(aParts[2]), parseInt(aParts[1]) - 1, parseInt(aParts[0]), 0, 0, 0, 0);
          const bDate = new Date(parseInt(bParts[2]), parseInt(bParts[1]) - 1, parseInt(bParts[0]), 0, 0, 0, 0);
          return aDate - bDate;
        });
      }
      case 'month':
        return getWeightedAverageGradeByDate(data, 'DATE', 'Actual_Tonnes', 'Actual_Grades', 'month').map(month => ({
          DATE: month.period,
          Planned_Tonnes: 0, // Not calculated for month
          Actual_Tonnes: month.totalTonnage,
          Planned_Grade: 0,
          Actual_Grades: month.weightedAverage,
          Planned_Content: 0,
          Actual_Content: 0
        }));
      case 'year':
        return getWeightedAverageGradeByDate(data, 'DATE', 'Actual_Tonnes', 'Actual_Grades', 'year').map(year => ({
          DATE: year.period,
          Planned_Tonnes: 0,
          Actual_Tonnes: year.totalTonnage,
          Planned_Grade: 0,
          Actual_Grades: year.weightedAverage,
          Planned_Content: 0,
          Actual_Content: 0
        }));
      default:
        return data;
    }
  };

  // Hoisting data loading effect
  useEffect(() => {
    if (selectedTab === 'hoisting' && !AllHoistingData && !hoistingLoading) {
      setHoistingLoading(true);
      fetch(HOISTING_CSV_PATH)
        .then((response) => {
          if (!response.ok) throw new Error('Failed to fetch Hoisting data');
          return response.text();
        })
        .then((csvText) => {
          const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });
          setAllHoistingData(parsed.data);
          setHoistingLoading(false);
        })
        .catch((err) => {
          setHoistingError(err.message);
          setHoistingLoading(false);
        });
    }
  }, [selectedTab, AllHoistingData, hoistingLoading]);

  // Hoisting bounds and filter effect
  useEffect(() => {
    if (AllHoistingData && AllHoistingData.length > 0) {
      // Use shared date bounds instead of calculating separate ones
      setHoistingDateBounds(sharedDateBounds);
      
      // Shared dates are handled by the shared state, no need to set individual dates
    }
  }, [AllHoistingData, sharedDateBounds, sharedStartDate, sharedEndDate]);

  // Hoisting filter effect
  useEffect(() => {
    if (AllHoistingData && sharedStartDate && sharedEndDate) {
      const start = parseInputDate(sharedStartDate);
      const end = parseInputDate(sharedEndDate);
      if (start && end) {
        const filtered = AllHoistingData.filter(row => {
          // Check date filter (inclusive of start and end)
          if (!row.DATE) return false;
          const parts = row.DATE.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            // Inclusive filter
            const dateInRange = rowDate >= start && rowDate <= end;
            return dateInRange;
          }
          return false;
        });
        setFilteredHoistingData(filtered);
      }
    }
  }, [AllHoistingData, sharedStartDate, sharedEndDate]);

  // Hoisting update summarized data effect
  useEffect(() => {
    if (filteredHoistingData) {
      const summarized = summarizeHoistingDataForCharts(filteredHoistingData, hoistingXAxisOption);
      setHoistingSummarizedChartData(summarized);
    }
  }, [filteredHoistingData, hoistingXAxisOption]);

  // Development summarization function
  const summarizeDevelopmentDataForCharts = (data, xAxisType) => {
    if (!data || data.length === 0) return [];
    switch (xAxisType) {
      case 'date': {
        const dateGroups = {};
        data.forEach(row => {
          if (!row.Date) return;
          const dateKey = row.Date;
          if (!dateGroups[dateKey]) {
            dateGroups[dateKey] = {
              date: dateKey,
              totalBudgetMetres: 0,
              totalActualMetres: 0,
              count: 0
            };
          }
          const budgetMetres = parseFloat(row.Budget_Metres) || 0;
          const actualMetres = parseFloat(row.Actual_Metres) || 0;
          dateGroups[dateKey].totalBudgetMetres += budgetMetres;
          dateGroups[dateKey].totalActualMetres += actualMetres;
          dateGroups[dateKey].count++;
        });
        return Object.values(dateGroups).map(group => ({
          ...group,
          Budget_Metres: group.totalBudgetMetres,
          Actual_Metres: group.totalActualMetres,
          Date: group.date
        })).sort((a, b) => {
          // Sort by date (DD/MM/YYYY format)
          const aParts = a.Date.split('/');
          const bParts = b.Date.split('/');
          const aDate = new Date(parseInt(aParts[2]), parseInt(aParts[1]) - 1, parseInt(aParts[0]), 0, 0, 0, 0);
          const bDate = new Date(parseInt(bParts[2]), parseInt(bParts[1]) - 1, parseInt(bParts[0]), 0, 0, 0, 0);
          return aDate - bDate;
        });
      }
      case 'month':
      case 'year': {
        const periodType = xAxisType;
        const groups = {};
        data.forEach(row => {
          if (!row.Date) return;
          let periodKey;
          if (periodType === 'month') {
            const [d, m, y] = row.Date.includes('/') ? row.Date.split('/').map(Number) : [null, null, null];
            periodKey = `${y}-${String(m).padStart(2, '0')}`;
          } else if (periodType === 'year') {
            const y = row.Date.includes('/') ? row.Date.split('/')[2] : null;
            periodKey = `${y}`;
          }
          if (!groups[periodKey]) {
            groups[periodKey] = {
              Budget_Metres: 0,
              Actual_Metres: 0,
              period: periodKey
            };
          }
          const budgetMetres = parseFloat(row.Budget_Metres) || 0;
          const actualMetres = parseFloat(row.Actual_Metres) || 0;
          groups[periodKey].Budget_Metres += budgetMetres;
          groups[periodKey].Actual_Metres += actualMetres;
        });
        return Object.values(groups).map(g => ({
          Date: g.period,
          Budget_Metres: g.Budget_Metres,
          Actual_Metres: g.Actual_Metres
        })).sort((a, b) => a.Date.localeCompare(b.Date));
      }
      default:
        return data;
    }
  };

  // Development data loading effect
  useEffect(() => {
    if (selectedTab === 'development' && !AllDevelopmentData && !developmentLoading) {
      setDevelopmentLoading(true);
      fetch(DEVELOPMENT_CSV_PATH)
        .then((response) => {
          if (!response.ok) throw new Error('Failed to fetch Development data');
          return response.text();
        })
        .then((csvText) => {
          const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });
          setAllDevelopmentData(parsed.data);
          setDevelopmentLoading(false);
        })
        .catch((err) => {
          setDevelopmentError(err.message);
          setDevelopmentLoading(false);
        });
    }
  }, [selectedTab, AllDevelopmentData, developmentLoading]);

  // Development bounds and filter effect
  useEffect(() => {
    if (AllDevelopmentData && AllDevelopmentData.length > 0) {
      // Use shared date bounds instead of calculating separate ones
      setDevelopmentDateBounds(sharedDateBounds);
      
      // Shared dates are handled by the shared state, no need to set individual dates
    }
  }, [AllDevelopmentData, sharedDateBounds, sharedStartDate, sharedEndDate]);

  // Development filter effect
  useEffect(() => {
    if (AllDevelopmentData && sharedStartDate && sharedEndDate) {
      const start = parseInputDate(sharedStartDate);
      const end = parseInputDate(sharedEndDate);
      if (start && end) {
        const filtered = AllDevelopmentData.filter(row => {
          // Check date filter (inclusive of start and end)
          if (!row.Date) return false;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            // Inclusive filter
            const dateInRange = rowDate >= start && rowDate <= end;
            return dateInRange;
          }
          return false;
        });
        setFilteredDevelopmentData(filtered);
      }
    }
  }, [AllDevelopmentData, sharedStartDate, sharedEndDate]);

  // Development update summarized data effect
  useEffect(() => {
    if (filteredDevelopmentData) {
      const summarized = summarizeDevelopmentDataForCharts(filteredDevelopmentData, developmentXAxisOption);
      setDevelopmentSummarizedChartData(summarized);
    }
  }, [filteredDevelopmentData, developmentXAxisOption]);

  // Extract all unique End_IDs when Development data loads
  useEffect(() => {
    if (AllDevelopmentData && AllDevelopmentData.length > 0) {
      const endIDs = [...new Set(AllDevelopmentData.map(row => row.End_ID && row.End_ID.trim()).filter(id => id))].sort();
      setAllEndIDs(endIDs);
      setSelectedEndIDs(endIDs);
      setTempSelectedEndIDs(endIDs);
    }
  }, [AllDevelopmentData]);

  // Filter Development data by End_ID
  useEffect(() => {
    if (AllDevelopmentData && sharedStartDate && sharedEndDate && selectedEndIDs.length > 0) {
      const start = parseInputDate(sharedStartDate);
      const end = parseInputDate(sharedEndDate);
      if (start && end) {
        const filtered = AllDevelopmentData.filter(row => {
          // Check date filter (inclusive of start and end)
          if (!row.Date) return false;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            // Inclusive filter
            const dateInRange = rowDate >= start && rowDate <= end;
            // End_ID filter
            const endID = row.End_ID && row.End_ID.trim();
            const endIDInRange = endID && selectedEndIDs.includes(endID);
            return dateInRange && endIDInRange;
          }
          return false;
        });
        setFilteredDevelopmentData(filtered);
      }
    }
  }, [AllDevelopmentData, sharedStartDate, sharedEndDate, selectedEndIDs]);

  // EndID filter handlers for Development
  const handleSelectAllEndIDs = () => setTempSelectedEndIDs([...allEndIDs]);
  const handleUnselectAllEndIDs = () => setTempSelectedEndIDs([]);
  const handleEndIDToggle = (endID) => setTempSelectedEndIDs(prev => prev.includes(endID) ? prev.filter(id => id !== endID) : [...prev, endID]);
  const handleApplyEndIDs = () => { setSelectedEndIDs([...tempSelectedEndIDs]); setShowEndIDFilter(false); };
  const handleCancelEndIDs = () => { setTempSelectedEndIDs([...selectedEndIDs]); setShowEndIDFilter(false); };
  const openEndIDFilter = () => { setTempSelectedEndIDs([...selectedEndIDs]); setShowEndIDFilter(true); };

  // Shared date range handlers
  const handleSharedStartDateChange = (newStartDate) => {
    setSharedStartDate(newStartDate);
  };

  const handleSharedEndDateChange = (newEndDate) => {
    setSharedEndDate(newEndDate);
  };

  // Summary data function to combine all datasets
  const summarizeSummaryDataForCharts = (stopingData, trammingData, hoistingData, developmentData, xAxisType) => {
    if (!stopingData || !trammingData || !hoistingData || !developmentData) return [];

    // Create a map to store combined data by period
    const combinedData = new Map();

    // Helper function to get period key based on xAxisType
    const getPeriodKey = (dateStr) => {
      if (!dateStr) return null;
      const parts = dateStr.split('/');
      if (parts.length !== 3) return null;
      
      const day = parseInt(parts[0]);
      const month = parseInt(parts[1]);
      const year = parseInt(parts[2]);
      
      switch (xAxisType) {
        case 'date':
          return dateStr; // DD/MM/YYYY
        case 'month':
          return `${month.toString().padStart(2, '0')}/${year}`; // MM/YYYY
        case 'year':
          return year.toString(); // YYYY
        default:
          return dateStr;
      }
    };

    // Helper function to initialize period entry
    const initializePeriodEntry = (periodKey) => {
      if (!combinedData.has(periodKey)) {
        combinedData.set(periodKey, {
          period: periodKey,
          // Stoping data
          Stoping_Actual_t: 0,
          Stoping_Budget_t: 0,
          Stoping_Actual_gpt_weighted_sum: 0, // For weighted average calculation
          Stoping_Budget_gpt_weighted_sum: 0, // For weighted average calculation
          Stoping_Actual_kgs: 0,
          Stoping_Budget_kgs: 0,
          // Tramming data
          Tramming_Actual_t: 0,
          Tramming_Budget_t: 0,
          Tramming_Actual_gpt_weighted_sum: 0, // For weighted average calculation
          Tramming_Budget_gpt_weighted_sum: 0, // For weighted average calculation
          Tramming_Actual_kgs: 0,
          Tramming_Budget_kgs: 0,
          // Hoisting data
          Planned_Tonnes: 0,
          Actual_Tonnes: 0,
          Planned_Grade_weighted_sum: 0, // For weighted average calculation
          Actual_Grades_weighted_sum: 0, // For weighted average calculation
          Planned_Content: 0,
          Actual_Content: 0,
          // Development data
          Budget_Metres: 0,
          Actual_Metres: 0
        });
      }
    };

    // Process Stoping data
    stopingData.forEach(row => {
      const periodKey = getPeriodKey(row.Date);
      if (!periodKey) return;
      
      initializePeriodEntry(periodKey);
      const entry = combinedData.get(periodKey);
      
      const actualTonnage = parseFloat(row.Stoping_Actual_t) || 0;
      const budgetTonnage = parseFloat(row.Stoping_Budget_t) || 0;
      const actualGrade = parseFloat(row.Stoping_Actual_gpt) || 0;
      const budgetGrade = parseFloat(row.Stoping_Budget_gpt) || 0;
      
      entry.Stoping_Actual_t += actualTonnage;
      entry.Stoping_Budget_t += budgetTonnage;
      entry.Stoping_Actual_gpt_weighted_sum += actualTonnage * actualGrade;
      entry.Stoping_Budget_gpt_weighted_sum += budgetTonnage * budgetGrade;
      entry.Stoping_Actual_kgs += parseFloat(row.Stoping_Actual_kgs) || 0;
      entry.Stoping_Budget_kgs += parseFloat(row.Stoping_Budget_kgs) || 0;
    });

    // Process Tramming data
    trammingData.forEach(row => {
      const periodKey = getPeriodKey(row.Date);
      if (!periodKey) return;
      
      initializePeriodEntry(periodKey);
      const entry = combinedData.get(periodKey);
      
      const actualTonnage = parseFloat(row.Tramming_Actual_t) || 0;
      const budgetTonnage = parseFloat(row.Tramming_Budget_t) || 0;
      const actualGrade = parseFloat(row.Tramming_Actual_gpt) || 0;
      const budgetGrade = parseFloat(row.Tramming_Budget_gpt) || 0;
      
      entry.Tramming_Actual_t += actualTonnage;
      entry.Tramming_Budget_t += budgetTonnage;
      entry.Tramming_Actual_gpt_weighted_sum += actualTonnage * actualGrade;
      entry.Tramming_Budget_gpt_weighted_sum += budgetTonnage * budgetGrade;
      entry.Tramming_Actual_kgs += parseFloat(row.Tramming_Actual_kgs) || 0;
      entry.Tramming_Budget_kgs += parseFloat(row.Tramming_Budget_kgs) || 0;
    });

    // Process Hoisting data
    hoistingData.forEach(row => {
      const periodKey = getPeriodKey(row.DATE);
      if (!periodKey) return;
      
      initializePeriodEntry(periodKey);
      const entry = combinedData.get(periodKey);
      
      const plannedTonnage = parseFloat(row.Planned_Tonnes) || 0;
      const actualTonnage = parseFloat(row.Actual_Tonnes) || 0;
      const plannedGrade = parseFloat(row.Planned_Grade) || 0;
      const actualGrade = parseFloat(row.Actual_Grades) || 0;
      
      entry.Planned_Tonnes += plannedTonnage;
      entry.Actual_Tonnes += actualTonnage;
      entry.Planned_Grade_weighted_sum += plannedTonnage * plannedGrade;
      entry.Actual_Grades_weighted_sum += actualTonnage * actualGrade;
      entry.Planned_Content += parseFloat(row.Planned_Content) || 0;
      entry.Actual_Content += parseFloat(row.Actual_Content) || 0;
    });

    // Process Development data
    developmentData.forEach(row => {
      const periodKey = getPeriodKey(row.Date);
      if (!periodKey) return;
      
      initializePeriodEntry(periodKey);
      const entry = combinedData.get(periodKey);
      
      entry.Budget_Metres += parseFloat(row.Budget_Metres) || 0;
      entry.Actual_Metres += parseFloat(row.Actual_Metres) || 0;
    });

    // Convert map to array, calculate weighted averages, and sort
    const result = Array.from(combinedData.values()).map(entry => {
      // Calculate weighted average grades
      const Stoping_Actual_gpt = entry.Stoping_Actual_t > 0 ? entry.Stoping_Actual_gpt_weighted_sum / entry.Stoping_Actual_t : 0;
      const Stoping_Budget_gpt = entry.Stoping_Budget_t > 0 ? entry.Stoping_Budget_gpt_weighted_sum / entry.Stoping_Budget_t : 0;
      const Tramming_Actual_gpt = entry.Tramming_Actual_t > 0 ? entry.Tramming_Actual_gpt_weighted_sum / entry.Tramming_Actual_t : 0;
      const Tramming_Budget_gpt = entry.Tramming_Budget_t > 0 ? entry.Tramming_Budget_gpt_weighted_sum / entry.Tramming_Budget_t : 0;
      const Planned_Grade = entry.Planned_Tonnes > 0 ? entry.Planned_Grade_weighted_sum / entry.Planned_Tonnes : 0;
      const Actual_Grades = entry.Actual_Tonnes > 0 ? entry.Actual_Grades_weighted_sum / entry.Actual_Tonnes : 0;

      return {
        period: entry.period,
        // Stoping data
        Stoping_Actual_t: entry.Stoping_Actual_t,
        Stoping_Budget_t: entry.Stoping_Budget_t,
        Stoping_Actual_gpt: Stoping_Actual_gpt,
        Stoping_Budget_gpt: Stoping_Budget_gpt,
        Stoping_Actual_kgs: entry.Stoping_Actual_kgs,
        Stoping_Budget_kgs: entry.Stoping_Budget_kgs,
        // Tramming data
        Tramming_Actual_t: entry.Tramming_Actual_t,
        Tramming_Budget_t: entry.Tramming_Budget_t,
        Tramming_Actual_gpt: Tramming_Actual_gpt,
        Tramming_Budget_gpt: Tramming_Budget_gpt,
        Tramming_Actual_kgs: entry.Tramming_Actual_kgs,
        Tramming_Budget_kgs: entry.Tramming_Budget_kgs,
        // Hoisting data
        Planned_Tonnes: entry.Planned_Tonnes,
        Actual_Tonnes: entry.Actual_Tonnes,
        Planned_Grade: Planned_Grade,
        Actual_Grades: Actual_Grades,
        Planned_Content: entry.Planned_Content,
        Actual_Content: entry.Actual_Content,
        // Development data
        Budget_Metres: entry.Budget_Metres,
        Actual_Metres: entry.Actual_Metres
      };
    }).sort((a, b) => {
      if (xAxisType === 'date') {
        const aParts = a.period.split('/');
        const bParts = b.period.split('/');
        const aDate = new Date(parseInt(aParts[2]), parseInt(aParts[1]) - 1, parseInt(aParts[0]));
        const bDate = new Date(parseInt(bParts[2]), parseInt(bParts[1]) - 1, parseInt(bParts[0]));
        return aDate - bDate;
      } else if (xAxisType === 'month') {
        const aParts = a.period.split('/');
        const bParts = b.period.split('/');
        const aDate = new Date(parseInt(aParts[1]), parseInt(aParts[0]) - 1);
        const bDate = new Date(parseInt(bParts[1]), parseInt(bParts[0]) - 1);
        return aDate - bDate;
      } else {
        return parseInt(a.period) - parseInt(b.period);
      }
    });

    return result;
  };

  // Shared date bounds calculation - runs when any dataset is loaded
  useEffect(() => {
    const allDates = [];
    
    // Collect dates from all datasets
    if (AllStopingData) {
      AllStopingData.forEach(row => {
        if (row.Date) {
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            allDates.push(new Date(year, month, day));
          }
        }
      });
    }
    
    if (AllTrammingData) {
      AllTrammingData.forEach(row => {
        if (row.Date) {
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            allDates.push(new Date(year, month, day));
          }
        }
      });
    }
    
    if (AllHoistingData) {
      AllHoistingData.forEach(row => {
        if (row.DATE) {
          const parts = row.DATE.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            allDates.push(new Date(year, month, day));
          }
        }
      });
    }
    
    if (AllDevelopmentData) {
      AllDevelopmentData.forEach(row => {
        if (row.Date) {
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            allDates.push(new Date(year, month, day));
          }
        }
      });
    }
    
    // Find min and max dates
    const validDates = allDates.filter(date => !isNaN(date.getTime())).sort((a, b) => a - b);
    if (validDates.length > 0) {
      const minDate = validDates[0];
      const maxDate = validDates[validDates.length - 1];
      setSharedDateBounds({ min: minDate, max: maxDate });
      
      // Set initial shared start and end dates if not already set
      if (!sharedStartDate) {
        setSharedStartDate(formatDateForInput(minDate));
      }
      if (!sharedEndDate) {
        setSharedEndDate(formatDateForInput(maxDate));
      }
    }
  }, [AllStopingData, AllTrammingData, AllHoistingData, AllDevelopmentData, sharedStartDate, sharedEndDate]);

  // Summary useEffect hooks
  // Calculate summary date bounds when all data is loaded
  useEffect(() => {
    if (AllStopingData && AllTrammingData && AllHoistingData && AllDevelopmentData) {
      // Use shared date bounds for summary
      setSummaryDateBounds(sharedDateBounds);
      
      // Shared dates are handled by the shared state, no need to set individual dates
    }
  }, [AllStopingData, AllTrammingData, AllHoistingData, AllDevelopmentData, sharedDateBounds, sharedStartDate, sharedEndDate]);

  // Filter summary data based on shared date range
  useEffect(() => {
    if (AllStopingData && AllTrammingData && AllHoistingData && AllDevelopmentData && sharedStartDate && sharedEndDate) {
      const start = parseInputDate(sharedStartDate);
      const end = parseInputDate(sharedEndDate);
      
      if (start && end) {
        // Filter Stoping data
        const filteredStoping = AllStopingData.filter(row => {
          if (!row.Date) return false;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            return rowDate >= start && rowDate <= end;
          }
          return false;
        });

        // Filter Tramming data
        const filteredTramming = AllTrammingData.filter(row => {
          if (!row.Date) return false;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            return rowDate >= start && rowDate <= end;
          }
          return false;
        });

        // Filter Hoisting data
        const filteredHoisting = AllHoistingData.filter(row => {
          if (!row.DATE) return false;
          const parts = row.DATE.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            return rowDate >= start && rowDate <= end;
          }
          return false;
        });

        // Filter Development data
        const filteredDevelopment = AllDevelopmentData.filter(row => {
          if (!row.Date) return false;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            return rowDate >= start && rowDate <= end;
          }
          return false;
        });

        // Create summarized data from filtered data
        const summarized = summarizeSummaryDataForCharts(
          filteredStoping, 
          filteredTramming, 
          filteredHoisting, 
          filteredDevelopment, 
          summaryXAxisOption
        );
        setSummarySummarizedChartData(summarized);
      }
    }
  }, [AllStopingData, AllTrammingData, AllHoistingData, AllDevelopmentData, sharedStartDate, sharedEndDate, summaryXAxisOption]);

  // Initialize default dates for processing (this month)
  useEffect(() => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    
    setFromDate(formatDateForInput(firstDay));
    setToDate(formatDateForInput(lastDay));
  }, []);

  // Load all processing data on component mount
  useEffect(() => {
    loadAllProcessingData();
  }, []);

  // Apply filters when dates change
  useEffect(() => {
    applyFilters();
  }, [fromDate, toDate, crushingData, mill1Data, mill3Data, mill4Data, goldProducedData, downtimeData, commentsData, millingPlanData]);

  // Processing data loading functions
  const loadAllProcessingData = async () => {
    console.log('BottomBar: Starting to load all processing data...');
    await Promise.all([
      loadCrushingData(),
      loadMill1Data(),
      loadMill3Data(),
      loadMill4Data(),
      loadGoldProducedData(),
      loadDowntimeData(),
      loadCommentsData(),
      loadMillingPlanData()
    ]);
    console.log('BottomBar: All processing data loading completed');
  };

  const loadCrushingData = async () => {
    setLoading(prev => ({ ...prev, crushing: true }));
    try {
      const response = await fetch(`${API_BASE_URL}/processing_crushing`);
      const data = await response.json();
      console.log('BottomBar: Crushing data loaded:', data);
      setCrushingData(data);
    } catch (error) {
      console.error('Error loading crushing data:', error);
    } finally {
      setLoading(prev => ({ ...prev, crushing: false }));
    }
  };

  const loadMill1Data = async () => {
    setLoading(prev => ({ ...prev, mill1: true }));
    try {
      const response = await fetch(`${API_BASE_URL}/processing_mill1`);
      const data = await response.json();
      console.log('BottomBar: Mill1 data loaded:', data);
      setMill1Data(data);
    } catch (error) {
      console.error('Error loading mill1 data:', error);
    } finally {
      setLoading(prev => ({ ...prev, mill1: false }));
    }
  };

  const loadMill3Data = async () => {
    setLoading(prev => ({ ...prev, mill3: true }));
    try {
      const response = await fetch(`${API_BASE_URL}/processing_mill3`);
      const data = await response.json();
      console.log('BottomBar: Mill3 data loaded:', data);
      setMill3Data(data);
    } catch (error) {
      console.error('Error loading mill3 data:', error);
    } finally {
      setLoading(prev => ({ ...prev, mill3: false }));
    }
  };

  const loadMill4Data = async () => {
    setLoading(prev => ({ ...prev, mill4: true }));
    try {
      const response = await fetch(`${API_BASE_URL}/processing_mill4`);
      const data = await response.json();
      console.log('BottomBar: Mill4 data loaded:', data);
      setMill4Data(data);
    } catch (error) {
      console.error('Error loading mill4 data:', error);
    } finally {
      setLoading(prev => ({ ...prev, mill4: false }));
    }
  };

  const loadGoldProducedData = async () => {
    setLoading(prev => ({ ...prev, goldProduced: true }));
    try {
      const response = await fetch(`${API_BASE_URL}/processing_producedgold`);
      const data = await response.json();
      console.log('BottomBar: Gold produced data loaded:', data);
      setGoldProducedData(data);
    } catch (error) {
      console.error('Error loading gold produced data:', error);
    } finally {
      setLoading(prev => ({ ...prev, goldProduced: false }));
    }
  };

  const loadDowntimeData = async () => {
    setLoading(prev => ({ ...prev, downtime: true }));
    try {
      const response = await fetch(`${API_BASE_URL}/processing_downtime`);
      const data = await response.json();
      console.log('BottomBar: Downtime data loaded:', data);
      setDowntimeData(data);
    } catch (error) {
      console.error('Error loading downtime data:', error);
    } finally {
      setLoading(prev => ({ ...prev, downtime: false }));
    }
  };

  const loadCommentsData = async () => {
    setLoading(prev => ({ ...prev, comments: true }));
    try {
      const response = await fetch(`${API_BASE_URL}/processing_comments`);
      const data = await response.json();
      console.log('BottomBar: Comments data loaded:', data);
      setCommentsData(data);
    } catch (error) {
      console.error('Error loading comments data:', error);
    } finally {
      setLoading(prev => ({ ...prev, comments: false }));
    }
  };

  const loadMillingPlanData = async () => {
    setLoading(prev => ({ ...prev, millingPlan: true }));
    try {
      const response = await fetch(`${API_BASE_URL}/processing_millingplan`);
      const data = await response.json();
      console.log('BottomBar: Milling plan data loaded:', data);
      setMillingPlanData(data);
    } catch (error) {
      console.error('Error loading milling plan data:', error);
    } finally {
      setLoading(prev => ({ ...prev, millingPlan: false }));
    }
  };

  // Date utility functions for processing
  const formatDateForChart = (date) => {
    const dateObj = new Date(date);
    const day = String(dateObj.getDate()).padStart(2, '0');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[dateObj.getMonth()];
    const year = dateObj.getFullYear();
    return `${day} ${month} ${year}`;
  };

  // Handle manual date input changes for processing
  const handleDateChange = (type, value) => {
    if (type === 'fromDate') {
      setFromDate(value);
    } else if (type === 'toDate') {
      setToDate(value);
    }
    // Reset active date range when manually changing dates
    setActiveDateRange('custom');
  };

  const toggleSection = (section) => {
    setCollapsedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const setProcessingDateRange = (type) => {
    const now = new Date();
    let startDate, endDate;

    switch (type) {
      case 'yesterday':
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        startDate = endDate = yesterday;
        break;
      case 'thisWeek':
        const startOfWeek = new Date(now);
        startOfWeek.setDate(now.getDate() - now.getDay());
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        startDate = startOfWeek;
        endDate = endOfWeek;
        break;
      case 'thisMonth':
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        break;
      case 'thisYear':
        startDate = new Date(now.getFullYear(), 0, 1);
        endDate = new Date(now.getFullYear(), 11, 31);
        break;
      default:
        return;
    }

    setActiveDateRange(type);
    setFromDate(formatDateForInput(startDate));
    setToDate(formatDateForInput(endDate));
  };

  const applyFilters = () => {
    if (!fromDate || !toDate) return;

    const filterData = (data) => {
      return data.filter(item => {
        const itemDate = new Date(item.DateReported);
        const from = new Date(fromDate);
        const to = new Date(toDate);
        return itemDate >= from && itemDate <= to;
      });
    };

    setFilteredData({
      crushing: filterData(crushingData),
      mill1: filterData(mill1Data),
      mill3: filterData(mill3Data),
      mill4: filterData(mill4Data),
      goldProduced: filterData(goldProducedData),
      downtime: filterData(downtimeData),
      comments: filterData(commentsData),
      millingPlan: filterData(millingPlanData)
    });
  };

  // Processing data processing functions for charts
  const processCrushingDataForCharts = (data) => {
    if (!data || data.length === 0) return [];
    
    return data
      .sort((a, b) => new Date(a.DateReported) - new Date(b.DateReported))
      .map(item => ({
        date: formatDateForChart(item.DateReported),
        tonnesCrushedDS: parseFloat(item.TonnesCrushed_DS) || 0,
        tonnesCrushedNS: parseFloat(item.TonnesCrushed_NS) || 0,
        tonnesCrushedDaily: parseFloat(item.TonnesCrushed_Daily) || 0
      }));
  };

  const processMillDataForCharts = (data) => {
    if (!data || data.length === 0) return [];
    
    return data
      .sort((a, b) => new Date(a.DateReported) - new Date(b.DateReported))
      .map(item => ({
        date: formatDateForChart(item.DateReported),
        tonnesMilledDS: parseFloat(item.TonnesMilled_DS) || 0,
        tonnesMilledNS: parseFloat(item.TonnesMilled_NS) || 0,
        tonnesMilledDaily: parseFloat(item.TonnesMilled_Daily) || 0
      }));
  };

  const processGoldProducedDataForCharts = (data) => {
    if (!data || data.length === 0) return [];
    
    return data
      .sort((a, b) => new Date(a.DateReported) - new Date(b.DateReported))
      .map(item => ({
        date: formatDateForChart(item.DateReported),
        bullionWeight: parseFloat(item.BullionWeight) || 0,
        goldSmelted: parseFloat(item.GoldSmelted) || 0
      }));
  };

  // Process daily vs plan data for crusher
  const processCrusherDailyVsPlan = (actualData, planData) => {
    if (!actualData || !planData || actualData.length === 0 || planData.length === 0) return [];
    
    return actualData
      .sort((a, b) => new Date(a.DateReported) - new Date(b.DateReported))
      .map((item, index) => {
        const planItem = planData[index] || {};
        return {
          date: formatDateForChart(item.DateReported),
          actual: parseFloat(item.TonnesCrushed_Daily) || 0,
          plan: parseFloat(planItem.TonnesCrushed) || 0
        };
      });
  };

  // Process cumulative vs cumulative plan data for crusher
  const processCrusherCumulativeVsPlan = (actualData, planData) => {
    if (!actualData || !planData || actualData.length === 0 || planData.length === 0) return [];
    
    let actualCumulative = 0;
    let planCumulative = 0;
    
    return actualData
      .sort((a, b) => new Date(a.DateReported) - new Date(b.DateReported))
      .map((item, index) => {
        actualCumulative += parseFloat(item.TonnesCrushed_Daily) || 0;
        planCumulative += parseFloat(planData[index]?.TonnesCrushed) || 0;
        
        return {
          date: formatDateForChart(item.DateReported),
          actualCumulative,
          planCumulative
        };
      });
  };

  // Process daily vs plan data for mills
  const processMillDailyVsPlan = (actualData, planData, millType) => {
    if (!actualData || !planData || actualData.length === 0 || planData.length === 0) return [];
    
    return actualData
      .sort((a, b) => new Date(a.DateReported) - new Date(b.DateReported))
      .map((item, index) => {
        const planItem = planData[index] || {};
        const planKey = millType === 'mill1' ? 'Mill1_TonnesMilled' : 
                       millType === 'mill3' ? 'Mill3_TonnesMilled' : 'Mill4_TonnesMilled';
        
        return {
          date: formatDateForChart(item.DateReported),
          actual: parseFloat(item.TonnesMilled_Daily) || 0,
          plan: parseFloat(planItem[planKey]) || 0
        };
      });
  };

  // Process cumulative vs cumulative plan data for mills
  const processMillCumulativeVsPlan = (actualData, planData, millType) => {
    if (!actualData || !planData || actualData.length === 0 || planData.length === 0) return [];
    
    let actualCumulative = 0;
    let planCumulative = 0;
    
    return actualData
      .sort((a, b) => new Date(a.DateReported) - new Date(b.DateReported))
      .map((item, index) => {
        actualCumulative += parseFloat(item.TonnesMilled_Daily) || 0;
        const planKey = millType === 'mill1' ? 'Mill1_TonnesMilled' : 
                       millType === 'mill3' ? 'Mill3_TonnesMilled' : 'Mill4_TonnesMilled';
        planCumulative += parseFloat(planData[index]?.[planKey]) || 0;
        
        return {
          date: formatDateForChart(item.DateReported),
          actualCumulative,
          planCumulative
        };
      });
  };

  // Process downtime data for charts
  const processDowntimeDataForCharts = (data) => {
    if (!data || data.length === 0) return [];
    
    return data
      .sort((a, b) => new Date(a.DateReported) - new Date(b.DateReported))
      .map(item => ({
        date: formatDateForChart(item.DateReported),
        crusherDowntime: parseFloat(item.Crusher_TotalDownTime_Daily) || 0,
        crusherAvailability: parseFloat(item.Crusher_Availability_Daily) || 0,
        crusherUtilization: parseFloat(item.Crusher_Utilization_Daily) || 0,
        mill1Downtime: parseFloat(item.Mill1_TotalDownTime_Daily) || 0,
        mill1Availability: parseFloat(item.Mill1_Availability_Daily) || 0,
        mill1Utilization: parseFloat(item.Mill1_Utilization_Daily) || 0,
        mill3Downtime: parseFloat(item.Mill3_TotalDownTime_Daily) || 0,
        mill3Availability: parseFloat(item.Mill3_Availability_Daily) || 0,
        mill3Utilization: parseFloat(item.Mill3_Utilization_Daily) || 0,
        mill4Downtime: parseFloat(item.Mill4_TotalDownTime_Daily) || 0,
        mill4Availability: parseFloat(item.Mill4_Availability_Daily) || 0,
        mill4Utilization: parseFloat(item.Mill4_Utilization_Daily) || 0
      }));
  };

  // console.log('BottomBar: Rendering with expanded:', expanded, 'className:', `bottomContainer${expanded ? ' expanded' : ''}`);
  
  return (
    <div className={`bottomContainer${expanded ? ' expanded' : ''}`}>
      {/* Tab Selector */}
      <div className="bottomBarTabSelector">
        {TAB_OPTIONS.map(tab => (
          <button
            key={tab.key}
            className={`bottomBarTabBtn${selectedTab === tab.key ? ' active' : ''}`}
            onClick={() => setSelectedTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {/* Tab Content */}
      {selectedTab === 'summary' && (
        <div className="bottomBarTabContent">
          {(!AllStopingData || !AllTrammingData || !AllHoistingData || !AllDevelopmentData || !sharedDateBounds.min || !sharedDateBounds.max) && (
            <div>Loading Summary data... Please ensure all individual tabs have loaded their data first.</div>
          )}
          {AllStopingData && AllTrammingData && AllHoistingData && AllDevelopmentData && sharedDateBounds.min && sharedDateBounds.max && (
            <>
              {/* Filters Row (date only) */}
              <div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
                <div className="dateRangeFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Date Range:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {summarySummarizedChartData ? `${summarySummarizedChartData.length} periods` : '0 periods'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>Start:</label>
                      <input
                        type="date"
                        value={sharedStartDate}
                        onChange={(e) => handleSharedStartDateChange(e.target.value)}
                        min={sharedDateBounds.min ? formatDateForInput(sharedDateBounds.min) : ''}
                        max={sharedDateBounds.max ? formatDateForInput(sharedDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>End:</label>
                      <input
                        type="date"
                        value={sharedEndDate}
                        onChange={(e) => handleSharedEndDateChange(e.target.value)}
                        min={sharedDateBounds.min ? formatDateForInput(sharedDateBounds.min) : ''}
                        max={sharedDateBounds.max ? formatDateForInput(sharedDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* X-Axis Selector */}
              <div className="xAxisSelector" style={{ margin: '10px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                <label style={{ fontWeight: 'bold', color: '#333', marginBottom: '8px', fontSize: '13px' }}>X-Axis:</label>
                <select value={summaryXAxisOption} onChange={(e) => setSummaryXAxisOption(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}>
                  <option value="date">Date</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </select>
              </div>
              {/* KPI Slider for Summary */}
              <div className="kpiSliderWrapper">
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Stoping Tonnes</p>
                    <p className="kpiValueText">{summarySummarizedChartData ? summarySummarizedChartData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Actual_t) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Tramming Tonnes</p>
                    <p className="kpiValueText">{summarySummarizedChartData ? summarySummarizedChartData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Actual_t) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Hoisting Tonnes</p>
                    <p className="kpiValueText">{summarySummarizedChartData ? summarySummarizedChartData.reduce((sum, row) => sum + (parseFloat(row.Actual_Tonnes) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Development Metres</p>
                    <p className="kpiValueText">{summarySummarizedChartData ? summarySummarizedChartData.reduce((sum, row) => sum + (parseFloat(row.Actual_Metres) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
              </div>
              {/* Graphs for Summary */}
              <div className="graphsWrapper">
                <div className="topGraphWrapper">
                  <div className="graph1">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={summarySummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="period" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = summaryXAxisOption === 'date' ? 'Date' : summaryXAxisOption === 'month' ? 'Month' : 'Year';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()}</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Stoping_Actual_t" name="Stoping Tonnes" fill="rgb(76,175,80)" />
                        <Bar dataKey="Tramming_Actual_t" name="Tramming Tonnes" fill="rgb(255,152,0)" />
                        <Bar dataKey="Actual_Tonnes" name="Hoisting Tonnes" fill="rgb(156,39,176)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="graph2">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={summarySummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="period" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toFixed(2)} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = summaryXAxisOption === 'date' ? 'Date' : summaryXAxisOption === 'month' ? 'Month' : 'Year';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toFixed(2)}</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Stoping_Actual_gpt" name="Stoping Grade" fill="rgb(76,175,80)" />
                        <Bar dataKey="Tramming_Actual_gpt" name="Tramming Grade" fill="rgb(255,152,0)" />
                        <Bar dataKey="Actual_Grades" name="Hoisting Grade" fill="rgb(156,39,176)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div className="bottomGraphWrapper">
                  <div className="graph3">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={summarySummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="period" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = summaryXAxisOption === 'date' ? 'Date' : summaryXAxisOption === 'month' ? 'Month' : 'Year';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()}</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Stoping_Actual_kgs" name="Stoping Kgs" fill="rgb(76,175,80)" />
                        <Bar dataKey="Tramming_Actual_kgs" name="Tramming Kgs" fill="rgb(255,152,0)" />
                        <Bar dataKey="Actual_Content" name="Hoisting Content" fill="rgb(156,39,176)" />
                        <Bar dataKey="Actual_Metres" name="Development Metres" fill="rgb(233,30,99)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {selectedTab === 'stoping' && (
        <div className="bottomBarTabContent">
          {stopingLoading && <div>Loading Stoping data...</div>}
          {stopingError && <div style={{ color: 'red' }}>Error: {stopingError}</div>}
          {AllStopingData && dateBounds.min && dateBounds.max && (
            <>
              {/* Filters Row */}
              <div style={{ 
                display: 'flex', 
                gap: '10px', 
                margin: '10px 0'
              }}>
                {/* Date Range Filter */}
                <div className="dateRangeFilter" style={{ 
                  flex: 1,
                  padding: '10px', 
                  backgroundColor: '#f5f5f5', 
                  borderRadius: '6px',
                  border: '1px solid #ddd'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: '8px' 
                  }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Date Range:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {filteredStopingData ? `${filteredStopingData.length} records` : '0 records'}
                    </span>
                  </div>
                  <div style={{ 
                    display: 'flex', 
                    gap: '10px', 
                    alignItems: 'center'
                  }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>
                        Start:
                      </label>
                      <input
                        type="date"
                        value={sharedStartDate}
                        onChange={(e) => handleSharedStartDateChange(e.target.value)}
                        min={sharedDateBounds.min ? formatDateForInput(sharedDateBounds.min) : ''}
                        max={sharedDateBounds.max ? formatDateForInput(sharedDateBounds.max) : ''}
                        style={{ 
                          width: '100%', 
                          padding: '5px', 
                          borderRadius: '4px', 
                          border: '1px solid #ccc', 
                          fontSize: '12px',
                          color: '#333'
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>
                        End:
                      </label>
                      <input
                        type="date"
                        value={sharedEndDate}
                        onChange={(e) => handleSharedEndDateChange(e.target.value)}
                        min={sharedDateBounds.min ? formatDateForInput(sharedDateBounds.min) : ''}
                        max={sharedDateBounds.max ? formatDateForInput(sharedDateBounds.max) : ''}
                        style={{ 
                          width: '100%', 
                          padding: '5px', 
                          borderRadius: '4px', 
                          border: '1px solid #ccc', 
                          fontSize: '12px',
                          color: '#333'
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Level Filter */}
                <div className="levelFilter" style={{ 
                  flex: 1,
                  padding: '10px', 
                  backgroundColor: '#f5f5f5', 
                  borderRadius: '6px',
                  border: '1px solid #ddd',
                  position: 'relative'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: '8px' 
                  }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Level Filter:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {selectedLevels.length} selected
                    </span>
                  </div>
                  <button 
                    onClick={openLevelFilter}
                    style={{ 
                      width: '100%',
                      padding: '8px', 
                      borderRadius: '4px', 
                      border: '1px solid #ccc', 
                      fontSize: '12px', 
                      color: '#333', 
                      backgroundColor: '#fff', 
                      cursor: 'pointer',
                      textAlign: 'left'
                    }}
                  >
                    {selectedLevels.length === allLevels.length 
                      ? 'All Levels Selected' 
                      : `${selectedLevels.length} of ${allLevels.length} Levels Selected`
                    }
                  </button>

                  {/* Level Filter Popup */}
                  {showLevelFilter && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      backgroundColor: '#fff',
                      border: '1px solid #ccc',
                      borderRadius: '6px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                      zIndex: 1000,
                      maxHeight: '300px',
                      overflow: 'hidden',
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {/* Level List */}
                      <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '10px',
                        maxHeight: '200px'
                      }}>
                        {allLevels.map(level => (
                          <div
                            key={level}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '5px 0',
                              cursor: 'pointer'
                            }}
                            onClick={() => handleLevelToggle(level)}
                          >
                            <input
                              type="checkbox"
                              checked={tempSelectedLevels.includes(level)}
                              onChange={() => handleLevelToggle(level)}
                              style={{ marginRight: '8px' }}
                            />
                            <span style={{ fontSize: '12px', color: '#333' }}>{level}</span>
                          </div>
                        ))}
                      </div>
                      
                      {/* Action Buttons */}
                      <div style={{
                        borderTop: '1px solid #eee',
                        padding: '8px',
                        display: 'flex',
                        gap: '4px',
                        justifyContent: 'space-between'
                      }}>
                        <button
                          onClick={handleSelectAllLevels}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#2196F3',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Select All
                        </button>
                        <button
                          onClick={handleUnselectAllLevels}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#FF9800',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Unselect All
                        </button>
                        <button
                          onClick={handleApplyLevelFilter}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#4CAF50',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Apply
                        </button>
                        <button
                          onClick={handleCancelLevelFilter}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#f44336',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Stope Filter */}
                <div className="stopeFilter" style={{ 
                  flex: 1,
                  padding: '10px', 
                  backgroundColor: '#f5f5f5', 
                  borderRadius: '6px',
                  border: '1px solid #ddd',
                  position: 'relative'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: '8px' 
                  }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Stope Filter:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {selectedStopeIds.length} selected
                    </span>
                  </div>
                  <button 
                    onClick={openStopeFilter}
                    style={{ 
                      width: '100%',
                      padding: '8px', 
                      borderRadius: '4px', 
                      border: '1px solid #ccc', 
                      fontSize: '12px', 
                      color: '#333', 
                      backgroundColor: '#fff', 
                      cursor: 'pointer',
                      textAlign: 'left'
                    }}
                  >
                    {selectedStopeIds.length === allStopeIds.length 
                      ? 'All Stopes Selected' 
                      : `${selectedStopeIds.length} of ${allStopeIds.length} Stopes Selected`
                    }
                  </button>

                  {/* Stope Filter Popup */}
                  {showStopeFilter && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      backgroundColor: '#fff',
                      border: '1px solid #ccc',
                      borderRadius: '6px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                      zIndex: 1000,
                      maxHeight: '300px',
                      overflow: 'hidden',
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {/* Stope List */}
                      <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '10px',
                        maxHeight: '200px'
                      }}>
                        {allStopeIds
                          .filter(stopeId => {
                            const levelMatch = stopeId.match(/^(\d+L)/);
                            const stopeLevel = levelMatch ? levelMatch[1] : null;
                            return stopeLevel && selectedLevels.includes(stopeLevel);
                          })
                          .map(stopeId => (
                          <div
                            key={stopeId}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '5px 0',
                              cursor: 'pointer'
                            }}
                            onClick={() => handleStopeToggle(stopeId)}
                          >
                            <input
                              type="checkbox"
                              checked={tempSelectedStopes.includes(stopeId)}
                              onChange={() => handleStopeToggle(stopeId)}
                              style={{ marginRight: '8px' }}
                            />
                            <span style={{ fontSize: '12px', color: '#333' }}>{stopeId}</span>
                          </div>
                        ))}
                      </div>
                      
                      {/* Action Buttons */}
                      <div style={{
                        borderTop: '1px solid #eee',
                        padding: '8px',
                        display: 'flex',
                        gap: '4px',
                        justifyContent: 'space-between'
                      }}>
                        <button
                          onClick={handleSelectAllStopes}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#2196F3',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Select All
                        </button>
                        <button
                          onClick={handleUnselectAllStopes}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#FF9800',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Unselect All
                        </button>
                        <button
                          onClick={handleApplyStopeFilter}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#4CAF50',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Apply
                        </button>
                        <button
                          onClick={handleCancelStopeFilter}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#f44336',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* X-Axis Selector */}
              <div className="xAxisSelector" style={{ 
                margin: '10px 0', 
                padding: '10px', 
                backgroundColor: '#f5f5f5', 
                borderRadius: '6px',
                border: '1px solid #ddd'
              }}>
                <label style={{ fontWeight: 'bold', color: '#333', marginBottom: '8px', fontSize: '13px' }}>X-Axis:</label>
                <select
                  value={xAxisOption}
                  onChange={(e) => setXAxisOption(e.target.value)}
                  style={{ 
                    width: '100%',
                    padding: '8px', 
                    borderRadius: '4px', 
                    border: '1px solid #ccc', 
                    fontSize: '12px', 
                    color: '#333'
                  }}
                >
                  <option value="date">Date</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                  <option value="stope">Stope</option>
                </select>
              </div>

                            {/* KPI Slider for Stoping */}
              <div className="kpiSliderWrapper kpiSliderWrapperCompact">
                <div className="groupedCompared">
                  <div className="kpiCardWrapper kpiCardWrapperCompact">
                    <p className="kpiHeadingText kpiHeadingTextCompact">Total FY2025 Plan Tonnage</p>
                    <p className="kpiValueText kpiValueTextCompact">{filteredStopingData ? filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.FY2025_Breaking_Plan_t) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper kpiCardWrapperCompact">
                    <p className="kpiHeadingText kpiHeadingTextCompact">Total Budget Tonnage</p>
                    <p className="kpiValueText kpiValueTextCompact">{filteredStopingData ? filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Budget_t) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper kpiCardWrapperCompact">
                    <p className="kpiHeadingText kpiHeadingTextCompact">Total Actual Tonnage</p>
                    <p className="kpiValueText kpiValueTextCompact">{filteredStopingData ? filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Actual_t) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper kpiCardWrapperCompact">
                    <p className="kpiHeadingText kpiHeadingTextCompact">Avg FY2025 Plan Grade</p>
                    <p className="kpiValueText kpiValueTextCompact">{(() => {
                      if (!filteredStopingData) return '-';
                      const totalTonnage = filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.FY2025_Breaking_Plan_t) || 0), 0);
                      const totalKgs = filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.FY2025_Breaking_Plan_kgs) || 0), 0);
                      return totalTonnage > 0 ? ((totalKgs / totalTonnage) * 1000).toFixed(2) : '-';
                    })()}</p>
                  </div>
                  <div className="kpiCardWrapper kpiCardWrapperCompact">
                    <p className="kpiHeadingText kpiHeadingTextCompact">Avg Budget Grade</p>
                    <p className="kpiValueText kpiValueTextCompact">{(() => {
                      if (!filteredStopingData) return '-';
                      const totalTonnage = filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Budget_t) || 0), 0);
                      const totalKgs = filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Budget_kgs) || 0), 0);
                      return totalTonnage > 0 ? ((totalKgs / totalTonnage) * 1000).toFixed(2) : '-';
                    })()}</p>
                  </div>
                  <div className="kpiCardWrapper kpiCardWrapperCompact">
                    <p className="kpiHeadingText kpiHeadingTextCompact">Avg Actual Grade</p>
                    <p className="kpiValueText kpiValueTextCompact">{(() => {
                      if (!filteredStopingData) return '-';
                      const totalTonnage = filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Actual_t) || 0), 0);
                      const totalKgs = filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Actual_kgs) || 0), 0);
                      return totalTonnage > 0 ? ((totalKgs / totalTonnage) * 1000).toFixed(2) : '-';
                    })()}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper kpiCardWrapperCompact">
                    <p className="kpiHeadingText kpiHeadingTextCompact">Total FY2025 Plan Kgs</p>
                    <p className="kpiValueText kpiValueTextCompact">{filteredStopingData ? filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.FY2025_Breaking_Plan_kgs) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper kpiCardWrapperCompact">
                    <p className="kpiHeadingText kpiHeadingTextCompact">Total Budget Kgs</p>
                    <p className="kpiValueText kpiValueTextCompact">{filteredStopingData ? filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Budget_kgs) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper kpiCardWrapperCompact">
                    <p className="kpiHeadingText kpiHeadingTextCompact">Total Actual Kgs</p>
                    <p className="kpiValueText kpiValueTextCompact">{filteredStopingData ? filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Actual_kgs) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
              </div>
              {/* Graphs for Stoping */}
              <div className="graphsWrapper">
                <div className="topGraphWrapper">
                  <div className="graph1">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={summarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip 
                          content={({ active, payload, label }) => {
                            if (active && payload && payload.length) {
                              const xAxisLabel = xAxisOption === 'date' ? 'Date' : 
                                                xAxisOption === 'month' ? 'Month' : 
                                                xAxisOption === 'year' ? 'Year' : 'Stope ID';
                              return (
                                <div style={{
                                  backgroundColor: '#fff',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  padding: '10px',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}>
                                  <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>
                                    {xAxisLabel}: {label}
                                  </p>
                                  {payload.map((entry, index) => (
                                    <p key={index} style={{ margin: '2px 0', color: entry.color }}>
                                      {entry.name}: {entry.value.toLocaleString()} tons
                                    </p>
                                  ))}
                                </div>
                              );
                            }
                            return null;
                          }}
                        />
                        <RechartsLegend />
                        <Bar dataKey="FY2025_Breaking_Plan_t" name="FY2025 Plan Tonnage" fill="rgb(156,39,176)" />
                        <Bar dataKey="Stoping_Budget_t" name="Budget Tonnage" fill="rgb(255,152,0)" />
                        <Bar dataKey="Stoping_Actual_t" name="Actual Tonnage" fill="rgb(76,175,80)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="graph2">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={summarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toFixed(2)} />
                        <RechartsTooltip 
                          content={({ active, payload, label }) => {
                            if (active && payload && payload.length) {
                              const xAxisLabel = xAxisOption === 'date' ? 'Date' : 
                                                xAxisOption === 'month' ? 'Month' : 
                                                xAxisOption === 'year' ? 'Year' : 'Stope ID';
                              return (
                                <div style={{
                                  backgroundColor: '#fff',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  padding: '10px',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}>
                                  <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>
                                    {xAxisLabel}: {label}
                                  </p>
                                  {payload.map((entry, index) => (
                                    <p key={index} style={{ margin: '2px 0', color: entry.color }}>
                                      {entry.name}: {entry.value.toFixed(2)} gpt
                                    </p>
                                  ))}
                                </div>
                              );
                            }
                            return null;
                          }}
                        />
                        <RechartsLegend />
                        <Bar dataKey="FY2025_Breaking_Plan_gpt" name="FY2025 Plan Grade" fill="rgb(156,39,176)" />
                        <Bar dataKey="Stoping_Budget_gpt" name="Budget Grade" fill="rgb(255,152,0)" />
                        <Bar dataKey="Stoping_Actual_gpt" name="Actual Grade" fill="rgb(76,175,80)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div className="bottomGraphWrapper">
                  <div className="graph3">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={summarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip 
                          content={({ active, payload, label }) => {
                            if (active && payload && payload.length) {
                              const xAxisLabel = xAxisOption === 'date' ? 'Date' : 
                                                xAxisOption === 'month' ? 'Month' : 
                                                xAxisOption === 'year' ? 'Year' : 'Stope ID';
                              return (
                                <div style={{
                                  backgroundColor: '#fff',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  padding: '10px',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}>
                                  <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>
                                    {xAxisLabel}: {label}
                                  </p>
                                  {payload.map((entry, index) => (
                                    <p key={index} style={{ margin: '2px 0', color: entry.color }}>
                                      {entry.name}: {entry.value.toLocaleString()} kgs
                                    </p>
                                  ))}
                                </div>
                              );
                            }
                            return null;
                          }}
                        />
                        <RechartsLegend />
                        <Bar dataKey="FY2025_Breaking_Plan_kgs" name="FY2025 Plan Kgs" fill="rgb(156,39,176)" />
                        <Bar dataKey="Stoping_Budget_kgs" name="Budget Kgs" fill="rgb(255,152,0)" />
                        <Bar dataKey="Stoping_Actual_kgs" name="Actual Kgs" fill="rgb(76,175,80)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {selectedTab === 'tramming' && (
        <div className="bottomBarTabContent">
          {trammingLoading && <div>Loading Tramming data...</div>}
          {trammingError && <div style={{ color: 'red' }}>Error: {trammingError}</div>}
          {AllTrammingData && trammingDateBounds.min && trammingDateBounds.max && (
            <>
              {/* Filters Row */}
              <div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
                {/* Date Range Filter */}
                <div className="dateRangeFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Date Range:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {filteredTrammingData ? `${filteredTrammingData.length} records` : '0 records'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>Start:</label>
                      <input
                        type="date"
                        value={sharedStartDate}
                        onChange={(e) => handleSharedStartDateChange(e.target.value)}
                        min={sharedDateBounds.min ? formatDateForInput(sharedDateBounds.min) : ''}
                        max={sharedDateBounds.max ? formatDateForInput(sharedDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>End:</label>
                      <input
                        type="date"
                        value={sharedEndDate}
                        onChange={(e) => handleSharedEndDateChange(e.target.value)}
                        min={sharedDateBounds.min ? formatDateForInput(sharedDateBounds.min) : ''}
                        max={sharedDateBounds.max ? formatDateForInput(sharedDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                  </div>
                </div>
                {/* Level Filter */}
                <div className="levelFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd', position: 'relative' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Level Filter:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>{trammingSelectedLevels.length} selected</span>
                  </div>
                  <button onClick={openTrammingLevelFilter} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333', backgroundColor: '#fff', cursor: 'pointer', textAlign: 'left' }}>
                    {trammingSelectedLevels.length === trammingAllLevels.length ? 'All Levels Selected' : `${trammingSelectedLevels.length} of ${trammingAllLevels.length} Levels Selected`}
                  </button>
                  {trammingShowLevelFilter && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '6px', boxShadow: '0 4px 8px rgba(0,0,0,0.2)', zIndex: 1000, maxHeight: '300px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                      <div style={{ flex: 1, overflowY: 'auto', padding: '10px', maxHeight: '200px' }}>
                        {trammingAllLevels.map(level => (
                          <div key={level} style={{ display: 'flex', alignItems: 'center', padding: '5px 0', cursor: 'pointer' }} onClick={() => handleTrammingLevelToggle(level)}>
                            <input type="checkbox" checked={trammingTempSelectedLevels.includes(level)} onChange={() => handleTrammingLevelToggle(level)} style={{ marginRight: '8px' }} />
                            <span style={{ fontSize: '12px', color: '#333' }}>{level}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ borderTop: '1px solid #eee', padding: '8px', display: 'flex', gap: '4px', justifyContent: 'space-between' }}>
                        <button onClick={handleTrammingSelectAllLevels} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#2196F3', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Select All</button>
                        <button onClick={handleTrammingUnselectAllLevels} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#FF9800', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Unselect All</button>
                        <button onClick={handleTrammingApplyLevelFilter} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#4CAF50', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Apply</button>
                        <button onClick={handleTrammingCancelLevelFilter} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#f44336', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Cancel</button>
                      </div>
                    </div>
                  )}
                </div>
                {/* Stope Filter */}
                <div className="stopeFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd', position: 'relative' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Stope Filter:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>{trammingSelectedStopeIds.length} selected</span>
                  </div>
                  <button onClick={openTrammingStopeFilter} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333', backgroundColor: '#fff', cursor: 'pointer', textAlign: 'left' }}>
                    {trammingSelectedStopeIds.length === trammingAllStopeIds.length ? 'All Stopes Selected' : `${trammingSelectedStopeIds.length} of ${trammingAllStopeIds.length} Stopes Selected`}
                  </button>
                  {trammingShowStopeFilter && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '6px', boxShadow: '0 4px 8px rgba(0,0,0,0.2)', zIndex: 1000, maxHeight: '300px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                      <div style={{ flex: 1, overflowY: 'auto', padding: '10px', maxHeight: '200px' }}>
                        {trammingAllStopeIds.filter(stopeId => {
                          const levelMatch = stopeId.match(/^([0-9]+L)/);
                          const stopeLevel = levelMatch ? levelMatch[1] : null;
                          return stopeLevel && trammingSelectedLevels.includes(stopeLevel);
                        }).map(stopeId => (
                          <div key={stopeId} style={{ display: 'flex', alignItems: 'center', padding: '5px 0', cursor: 'pointer' }} onClick={() => handleTrammingStopeToggle(stopeId)}>
                            <input type="checkbox" checked={trammingTempSelectedStopes.includes(stopeId)} onChange={() => handleTrammingStopeToggle(stopeId)} style={{ marginRight: '8px' }} />
                            <span style={{ fontSize: '12px', color: '#333' }}>{stopeId}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ borderTop: '1px solid #eee', padding: '8px', display: 'flex', gap: '4px', justifyContent: 'space-between' }}>
                        <button onClick={handleTrammingSelectAllStopes} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#2196F3', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Select All</button>
                        <button onClick={handleTrammingUnselectAllStopes} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#FF9800', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Unselect All</button>
                        <button onClick={handleTrammingApplyStopeFilter} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#4CAF50', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Apply</button>
                        <button onClick={handleTrammingCancelStopeFilter} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#f44336', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Cancel</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* X-Axis Selector */}
              <div className="xAxisSelector" style={{ margin: '10px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                <label style={{ fontWeight: 'bold', color: '#333', marginBottom: '8px', fontSize: '13px' }}>X-Axis:</label>
                <select value={trammingXAxisOption} onChange={(e) => setTrammingXAxisOption(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}>
                  <option value="date">Date</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                  <option value="stope">Stope</option>
                </select>
              </div>
              {/* KPI Slider for Tramming */}
              <div className="kpiSliderWrapper">
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Actual Tonnage</p>
                    <p className="kpiValueText">{filteredTrammingData ? filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Actual_t) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Budget Tonnage</p>
                    <p className="kpiValueText">{filteredTrammingData ? filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Budget_t) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Avg Actual Grade</p>
                    <p className="kpiValueText">{(() => {
                      if (!filteredTrammingData) return '-';
                      const totalTonnage = filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Actual_t) || 0), 0);
                      const totalKgs = filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Actual_kgs) || 0), 0);
                      return totalTonnage > 0 ? ((totalKgs / totalTonnage) * 1000).toFixed(2) : '-';
                    })()}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Avg Budget Grade</p>
                    <p className="kpiValueText">{(() => {
                      if (!filteredTrammingData) return '-';
                      const totalTonnage = filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Budget_t) || 0), 0);
                      const totalKgs = filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Budget_kgs) || 0), 0);
                      return totalTonnage > 0 ? ((totalKgs / totalTonnage) * 1000).toFixed(2) : '-';
                    })()}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Actual Kgs</p>
                    <p className="kpiValueText">{filteredTrammingData ? filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Actual_kgs) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Budget Kgs</p>
                    <p className="kpiValueText">{filteredTrammingData ? filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Budget_kgs) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
              </div>
              {/* Graphs for Tramming */}
              <div className="graphsWrapper">
                <div className="topGraphWrapper">
                  <div className="graph1">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={trammingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = trammingXAxisOption === 'date' ? 'Date' : trammingXAxisOption === 'month' ? 'Month' : trammingXAxisOption === 'year' ? 'Year' : 'Stope ID';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()} tons</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Tramming_Actual_t" name="Actual Tonnage" fill="rgb(76,175,80)" />
                        <Bar dataKey="Tramming_Budget_t" name="Budget Tonnage" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="graph2">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={trammingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toFixed(2)} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = trammingXAxisOption === 'date' ? 'Date' : trammingXAxisOption === 'month' ? 'Month' : trammingXAxisOption === 'year' ? 'Year' : 'Stope ID';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toFixed(2)} gpt</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Tramming_Actual_gpt" name="Actual Grade" fill="rgb(76,175,80)" />
                        <Bar dataKey="Tramming_Budget_gpt" name="Budget Grade" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div className="bottomGraphWrapper">
                  <div className="graph3">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={trammingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = trammingXAxisOption === 'date' ? 'Date' : trammingXAxisOption === 'month' ? 'Month' : trammingXAxisOption === 'year' ? 'Year' : 'Stope ID';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()} kgs</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Tramming_Actual_kgs" name="Actual Kgs" fill="rgb(76,175,80)" />
                        <Bar dataKey="Tramming_Budget_kgs" name="Budget Kgs" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {selectedTab === 'hoisting' && (
        <div className="bottomBarTabContent">
          {hoistingLoading && <div>Loading Hoisting data...</div>}
          {hoistingError && <div style={{ color: 'red' }}>Error: {hoistingError}</div>}
          {AllHoistingData && hoistingDateBounds.min && hoistingDateBounds.max && (
            <>
              {/* Filters Row (date only) */}
              <div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
                <div className="dateRangeFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Date Range:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {filteredHoistingData ? `${filteredHoistingData.length} records` : '0 records'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>Start:</label>
                      <input
                        type="date"
                        value={sharedStartDate}
                        onChange={(e) => handleSharedStartDateChange(e.target.value)}
                        min={sharedDateBounds.min ? formatDateForInput(sharedDateBounds.min) : ''}
                        max={sharedDateBounds.max ? formatDateForInput(sharedDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>End:</label>
                      <input
                        type="date"
                        value={sharedEndDate}
                        onChange={(e) => handleSharedEndDateChange(e.target.value)}
                        min={sharedDateBounds.min ? formatDateForInput(sharedDateBounds.min) : ''}
                        max={sharedDateBounds.max ? formatDateForInput(sharedDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* X-Axis Selector */}
              <div className="xAxisSelector" style={{ margin: '10px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                <label style={{ fontWeight: 'bold', color: '#333', marginBottom: '8px', fontSize: '13px' }}>X-Axis:</label>
                <select value={hoistingXAxisOption} onChange={(e) => setHoistingXAxisOption(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}>
                  <option value="date">Date</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </select>
              </div>
              {/* KPI Slider for Hoisting */}
              <div className="kpiSliderWrapper">
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Planned Tonnes</p>
                    <p className="kpiValueText">{filteredHoistingData ? filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Planned_Tonnes) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Actual Tonnes</p>
                    <p className="kpiValueText">{filteredHoistingData ? filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Actual_Tonnes) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Avg Planned Grade</p>
                    <p className="kpiValueText">{(() => {
                      if (!filteredHoistingData) return '-';
                      const totalTonnage = filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Planned_Tonnes) || 0), 0);
                      const totalGrade = filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Planned_Tonnes) || 0) * (parseFloat(row.Planned_Grade) || 0), 0);
                      return totalTonnage > 0 ? (totalGrade / totalTonnage).toFixed(2) : '-';
                    })()}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Avg Actual Grade</p>
                    <p className="kpiValueText">{(() => {
                      if (!filteredHoistingData) return '-';
                      const totalTonnage = filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Actual_Tonnes) || 0), 0);
                      const totalGrade = filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Actual_Tonnes) || 0) * (parseFloat(row.Actual_Grades) || 0), 0);
                      return totalTonnage > 0 ? (totalGrade / totalTonnage).toFixed(2) : '-';
                    })()}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Planned Content</p>
                    <p className="kpiValueText">{filteredHoistingData ? filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Planned_Content) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Actual Content</p>
                    <p className="kpiValueText">{filteredHoistingData ? filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Actual_Content) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
              </div>
              {/* Graphs for Hoisting */}
              <div className="graphsWrapper">
                <div className="topGraphWrapper">
                  <div className="graph1">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={hoistingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="DATE" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = hoistingXAxisOption === 'date' ? 'Date' : hoistingXAxisOption === 'month' ? 'Month' : 'Year';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()}</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Planned_Tonnes" name="Planned Tonnes" fill="rgb(76,175,80)" />
                        <Bar dataKey="Actual_Tonnes" name="Actual Tonnes" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="graph2">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={hoistingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="DATE" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = hoistingXAxisOption === 'date' ? 'Date' : hoistingXAxisOption === 'month' ? 'Month' : 'Year';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toFixed(2)}</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Planned_Grade" name="Planned Grade" fill="rgb(76,175,80)" />
                        <Bar dataKey="Actual_Grades" name="Actual Grade" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div className="bottomGraphWrapper">
                  <div className="graph3">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={hoistingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="DATE" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = hoistingXAxisOption === 'date' ? 'Date' : hoistingXAxisOption === 'month' ? 'Month' : 'Year';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()}</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Planned_Content" name="Planned Content" fill="rgb(76,175,80)" />
                        <Bar dataKey="Actual_Content" name="Actual Content" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {selectedTab === 'development' && (
        <div className="bottomBarTabContent">
          {developmentLoading && <div>Loading Development data...</div>}
          {developmentError && <div style={{ color: 'red' }}>Error: {developmentError}</div>}
          {AllDevelopmentData && developmentDateBounds.min && developmentDateBounds.max && (
            <>
              {/* Filters Row (date + EndID) */}
              <div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
                <div className="dateRangeFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Date Range:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {filteredDevelopmentData ? `${filteredDevelopmentData.length} records` : '0 records'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>Start:</label>
                      <input
                        type="date"
                        value={sharedStartDate}
                        onChange={(e) => handleSharedStartDateChange(e.target.value)}
                        min={sharedDateBounds.min ? formatDateForInput(sharedDateBounds.min) : ''}
                        max={sharedDateBounds.max ? formatDateForInput(sharedDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>End:</label>
                      <input
                        type="date"
                        value={sharedEndDate}
                        onChange={(e) => handleSharedEndDateChange(e.target.value)}
                        min={sharedDateBounds.min ? formatDateForInput(sharedDateBounds.min) : ''}
                        max={sharedDateBounds.max ? formatDateForInput(sharedDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                  </div>
                </div>
                {/* EndID Filter */}
                <div className="endIDFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd', position: 'relative' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>EndID Filter:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>{selectedEndIDs.length} selected</span>
                  </div>
                  <button onClick={openEndIDFilter} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333', backgroundColor: '#fff', cursor: 'pointer', textAlign: 'left' }}>
                    {selectedEndIDs.length === allEndIDs.length ? 'All EndIDs Selected' : `${selectedEndIDs.length} of ${allEndIDs.length} EndIDs Selected`}
                  </button>
                  {showEndIDFilter && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '6px', boxShadow: '0 4px 8px rgba(0,0,0,0.2)', zIndex: 1000, maxHeight: '300px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                      <div style={{ flex: 1, overflowY: 'auto', padding: '10px', maxHeight: '200px' }}>
                        {allEndIDs.map(endID => (
                          <div key={endID} style={{ display: 'flex', alignItems: 'center', padding: '5px 0', cursor: 'pointer' }} onClick={() => handleEndIDToggle(endID)}>
                            <input type="checkbox" checked={tempSelectedEndIDs.includes(endID)} onChange={() => handleEndIDToggle(endID)} style={{ marginRight: '8px' }} />
                            <span style={{ fontSize: '12px', color: '#333' }}>{endID}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ borderTop: '1px solid #eee', padding: '8px', display: 'flex', gap: '4px', justifyContent: 'space-between' }}>
                        <button onClick={handleSelectAllEndIDs} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#2196F3', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Select All</button>
                        <button onClick={handleUnselectAllEndIDs} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#FF9800', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Unselect All</button>
                        <button onClick={handleApplyEndIDs} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#4CAF50', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Apply</button>
                        <button onClick={handleCancelEndIDs} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#f44336', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Cancel</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* X-Axis Selector */}
              <div className="xAxisSelector" style={{ margin: '10px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                <label style={{ fontWeight: 'bold', color: '#333', marginBottom: '8px', fontSize: '13px' }}>X-Axis:</label>
                <select value={developmentXAxisOption} onChange={(e) => setDevelopmentXAxisOption(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}>
                  <option value="date">Date</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </select>
              </div>
              {/* KPI Slider for Development */}
              <div className="kpiSliderWrapper">
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Budget Metres</p>
                    <p className="kpiValueText">{filteredDevelopmentData ? filteredDevelopmentData.reduce((sum, row) => sum + (parseFloat(row.Budget_Metres) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Actual Metres</p>
                    <p className="kpiValueText">{filteredDevelopmentData ? filteredDevelopmentData.reduce((sum, row) => sum + (parseFloat(row.Actual_Metres) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
              </div>
              {/* Graphs for Development */}
              <div style={{ width: '100%', height: 400, marginTop: 20 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={developmentSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                    <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                    <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                    <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                    <RechartsTooltip content={({ active, payload, label }) => {
                      if (active && payload && payload.length) {
                        const xAxisLabel = developmentXAxisOption === 'date' ? 'Date' : developmentXAxisOption === 'month' ? 'Month' : 'Year';
                        return (
                          <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                            <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                            {payload.map((entry, index) => (
                              <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()} m</p>
                            ))}
                          </div>
                        );
                      }
                      return null;
                    }} />
                    <RechartsLegend />
                    <Bar dataKey="Budget_Metres" name="Budget Metres" fill="rgb(76,175,80)" />
                    <Bar dataKey="Actual_Metres" name="Actual Metres" fill="rgb(255,152,0)" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </>
          )}
        </div>
      )}
      {/* Processing Tabs */}
      {selectedTab === 'filters' && (
        <div className="bottomBarTabContent">
          <div className="filters-container">
            <div className="filters-header">
              <h3>Data Filters</h3>
              <p>Set date range to filter all processing data</p>
            </div>
            
            <div className="date-filters">
              <div className="date-range-section">
                <div className="date-input-group">
                  <label htmlFor="fromDate">From Date:</label>
                  <input
                    type="date"
                    id="fromDate"
                    value={fromDate}
                    onChange={(e) => handleDateChange('fromDate', e.target.value)}
                    className="date-input"
                  />
                </div>
                
                <div className="date-input-group">
                  <label htmlFor="toDate">To Date:</label>
                  <input
                    type="date"
                    id="toDate"
                    value={toDate}
                    onChange={(e) => handleDateChange('toDate', e.target.value)}
                    className="date-input"
                  />
                </div>
              </div>
              
              <div className="quick-date-buttons">
                <h4>Quick Date Selection:</h4>
                <div className="date-buttons">
                  <button 
                    className={`date-btn ${activeDateRange === 'yesterday' ? 'active' : ''}`}
                    onClick={() => setProcessingDateRange('yesterday')}
                  >
                    Yesterday
                  </button>
                  <button 
                    className={`date-btn ${activeDateRange === 'thisWeek' ? 'active' : ''}`}
                    onClick={() => setProcessingDateRange('thisWeek')}
                  >
                    This Week
                  </button>
                  <button 
                    className={`date-btn ${activeDateRange === 'thisMonth' ? 'active' : ''}`}
                    onClick={() => setProcessingDateRange('thisMonth')}
                  >
                    This Month
                  </button>
                  <button 
                    className={`date-btn ${activeDateRange === 'thisYear' ? 'active' : ''}`}
                    onClick={() => setProcessingDateRange('thisYear')}
                  >
                    This Year
                  </button>
                </div>
              </div>
            </div>
            
            <div className="filter-summary">
              <h4>Filter Results:</h4>
              <div className="filter-stats">
                <div className="stat-item">
                  <span className="stat-label">Crushing Records:</span>
                  <span className="stat-value">{filteredData.crushing?.length || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Mill1 Records:</span>
                  <span className="stat-value">{filteredData.mill1?.length || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Mill3 Records:</span>
                  <span className="stat-value">{filteredData.mill3?.length || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Mill4 Records:</span>
                  <span className="stat-value">{filteredData.mill4?.length || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Gold Produced:</span>
                  <span className="stat-value">{filteredData.goldProduced?.length || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Downtime Records:</span>
                  <span className="stat-value">{filteredData.downtime?.length || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Comments:</span>
                  <span className="stat-value">{filteredData.comments?.length || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Milling Plan:</span>
                  <span className="stat-value">{filteredData.millingPlan?.length || 0}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {selectedTab === 'crusher' && (
        <div className="bottomBarTabContent">
          <div className="crusher-tab">
            <h3>Crusher Performance</h3>
            {loading.crushing ? (
              <div className="loading">Loading crushing data...</div>
            ) : (
              <div className="charts-container">
                {/* Daily vs Plan Chart */}
                <div className="chart-section">
                  <h4>Daily vs Plan</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processCrusherDailyVsPlan(filteredData.crushing, filteredData.millingPlan)}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="actual" stroke="#ff6b6b" name="Actual" />
                      <Line type="monotone" dataKey="plan" stroke="#4ecdc4" name="Plan" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                {/* Cumulative vs Cumulative Plan Chart */}
                <div className="chart-section">
                  <h4>Cumulative vs Cumulative Plan</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processCrusherCumulativeVsPlan(filteredData.crushing, filteredData.millingPlan)}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="actualCumulative" stroke="#ff6b6b" name="Actual Cumulative" />
                      <Line type="monotone" dataKey="planCumulative" stroke="#4ecdc4" name="Plan Cumulative" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                {/* Daily, NS, DS Chart */}
                <div className="chart-section">
                  <h4>Daily, NS, DS Performance</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processCrushingDataForCharts(filteredData.crushing)}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="tonnesCrushedDS" stroke="#8884d8" name="Tonnes Crushed DS" />
                      <Line type="monotone" dataKey="tonnesCrushedNS" stroke="#82ca9d" name="Tonnes Crushed NS" />
                      <Line type="monotone" dataKey="tonnesCrushedDaily" stroke="#ffc658" name="Tonnes Crushed Daily" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {selectedTab === 'mill1' && (
        <div className="bottomBarTabContent">
          <div className="mill1-tab">
            <h3>Mill1 Performance</h3>
            {loading.mill1 ? (
              <div className="loading">Loading mill1 data...</div>
            ) : (
              <div className="charts-container">
                {/* Daily vs Plan Chart */}
                <div className="chart-section">
                  <h4>Daily vs Plan</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processMillDailyVsPlan(filteredData.mill1, filteredData.millingPlan, 'mill1')}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="actual" stroke="#ff6b6b" name="Actual" />
                      <Line type="monotone" dataKey="plan" stroke="#4ecdc4" name="Plan" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                {/* Cumulative vs Cumulative Plan Chart */}
                <div className="chart-section">
                  <h4>Cumulative vs Cumulative Plan</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processMillCumulativeVsPlan(filteredData.mill1, filteredData.millingPlan, 'mill1')}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="actualCumulative" stroke="#ff6b6b" name="Actual Cumulative" />
                      <Line type="monotone" dataKey="planCumulative" stroke="#4ecdc4" name="Plan Cumulative" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                {/* Daily, NS, DS Chart */}
                <div className="chart-section">
                  <h4>Daily, NS, DS Performance</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processMillDataForCharts(filteredData.mill1)}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="tonnesMilledDS" stroke="#8884d8" name="Tonnes Milled DS" />
                      <Line type="monotone" dataKey="tonnesMilledNS" stroke="#82ca9d" name="Tonnes Milled NS" />
                      <Line type="monotone" dataKey="tonnesMilledDaily" stroke="#ffc658" name="Tonnes Milled Daily" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {selectedTab === 'mill3' && (
        <div className="bottomBarTabContent">
          <div className="mill3-tab">
            <h3>Mill3 Performance</h3>
            {loading.mill3 ? (
              <div className="loading">Loading mill3 data...</div>
            ) : (
              <div className="charts-container">
                {/* Daily vs Plan Chart */}
                <div className="chart-section">
                  <h4>Daily vs Plan</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processMillDailyVsPlan(filteredData.mill3, filteredData.millingPlan, 'mill3')}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="actual" stroke="#ff6b6b" name="Actual" />
                      <Line type="monotone" dataKey="plan" stroke="#4ecdc4" name="Plan" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                {/* Cumulative vs Cumulative Plan Chart */}
                <div className="chart-section">
                  <h4>Cumulative vs Cumulative Plan</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processMillCumulativeVsPlan(filteredData.mill3, filteredData.millingPlan, 'mill3')}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="actualCumulative" stroke="#ff6b6b" name="Actual Cumulative" />
                      <Line type="monotone" dataKey="planCumulative" stroke="#4ecdc4" name="Plan Cumulative" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                {/* Daily, NS, DS Chart */}
                <div className="chart-section">
                  <h4>Daily, NS, DS Performance</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processMillDataForCharts(filteredData.mill3)}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="tonnesMilledDS" stroke="#8884d8" name="Tonnes Milled DS" />
                      <Line type="monotone" dataKey="tonnesMilledNS" stroke="#82ca9d" name="Tonnes Milled NS" />
                      <Line type="monotone" dataKey="tonnesMilledDaily" stroke="#ffc658" name="Tonnes Milled Daily" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {selectedTab === 'mill4' && (
        <div className="bottomBarTabContent">
          <div className="mill4-tab">
            <h3>Mill4 Performance</h3>
            {loading.mill4 ? (
              <div className="loading">Loading mill4 data...</div>
            ) : (
              <div className="charts-container">
                {/* Daily vs Plan Chart */}
                <div className="chart-section">
                  <h4>Daily vs Plan</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processMillDailyVsPlan(filteredData.mill4, filteredData.millingPlan, 'mill4')}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="actual" stroke="#ff6b6b" name="Actual" />
                      <Line type="monotone" dataKey="plan" stroke="#4ecdc4" name="Plan" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                {/* Cumulative vs Cumulative Plan Chart */}
                <div className="chart-section">
                  <h4>Cumulative vs Cumulative Plan</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processMillCumulativeVsPlan(filteredData.mill4, filteredData.millingPlan, 'mill4')}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="actualCumulative" stroke="#ff6b6b" name="Actual Cumulative" />
                      <Line type="monotone" dataKey="planCumulative" stroke="#4ecdc4" name="Plan Cumulative" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                {/* Daily, NS, DS Chart */}
                <div className="chart-section">
                  <h4>Daily, NS, DS Performance</h4>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={processMillDataForCharts(filteredData.mill4)}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="tonnesMilledDS" stroke="#8884d8" name="Tonnes Milled DS" />
                      <Line type="monotone" dataKey="tonnesMilledNS" stroke="#82ca9d" name="Tonnes Milled NS" />
                      <Line type="monotone" dataKey="tonnesMilledDaily" stroke="#ffc658" name="Tonnes Milled Daily" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {selectedTab === 'downtime' && (
        <div className="bottomBarTabContent">
          <div className="downtime-tab">
            <h3>Equipment Performance Metrics</h3>
            {loading.downtime || loading.millingPlan ? (
              <div className="loading">Loading downtime and plan data...</div>
            ) : (
              <div className="charts-container">
                <div className="chart-section">
                  <h4>Downtime Analysis</h4>
                  <ResponsiveContainer width="100%" height={400}>
                    <LineChart data={processDowntimeDataForCharts(filteredData.downtime)}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <RechartsTooltip />
                      <RechartsLegend />
                      <Line type="monotone" dataKey="crusherDowntime" stroke="#ff6b6b" name="Crusher Downtime" />
                      <Line type="monotone" dataKey="mill1Downtime" stroke="#4ecdc4" name="Mill1 Downtime" />
                      <Line type="monotone" dataKey="mill3Downtime" stroke="#45b7d1" name="Mill3 Downtime" />
                      <Line type="monotone" dataKey="mill4Downtime" stroke="#96ceb4" name="Mill4 Downtime" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {selectedTab === 'goldproduced' && (
        <div className="bottomBarTabContent">
          <div className="gold-produced-tab">
            <h3>Gold Production</h3>
            {loading.goldProduced ? (
              <div className="loading">Loading gold produced data...</div>
            ) : (
              <div className="chart-container">
                <ResponsiveContainer width="100%" height={400}>
                  <BarChart data={processGoldProducedDataForCharts(filteredData.goldProduced)}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <RechartsTooltip />
                    <RechartsLegend />
                    <Bar dataKey="bullionWeight" fill="#ffa400" name="Bullion Weight" />
                    <Bar dataKey="goldSmelted" fill="#ff7300" name="Gold Smelted" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BottomBar; 